import React, { useMemo, useRef, useEffect, useState } from 'react';
import { Card, Col, Row, Modal, Button, Nav, Tab } from 'react-bootstrap';
import PageTitle from '../../includes/PageTitle';
import Tables from "../../components/Tables/Tables";
import Modals from "../../components/Modals/Modals";
import SelectFild from '../../components/SelectFild/SelectFild';
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import Loader from '../../components/Loader/Loader';
import { FaLandmark, FaEdit, FaTrashAlt, FaCheckCircle, FaFilePdf, FaEye } from "react-icons/fa";
import Autocomplete from '../../components/Autocomplete/Autocomplete';
import AutoCompleteMobile from '../../components/AutoCompleteMobile/AutoCompleteMobile';
import DateFild from '../../components/DateTimePicker/DateFild';
import DateToDayFild from '../../components/DateTimePicker/DateToDayFild';
import TimeFild from '../../components/DateTimePicker/TimeFild';
import Address from '../../components/Address/Address';
import Gst from '../../components/Gst/Gst';
import BankInfo from '../../components/BankInfo/BankInfo';
import ContactPerson from '../../components/ContactPerson/ContactPerson';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
    ClassicEditor,
    Essentials,
    Paragraph,
    Heading,
    Bold,
    Italic,
    Underline,
    Strikethrough,
    Code,
    Subscript,
    Superscript,
    Font,
    FontFamily,
    FontSize,
    FontColor,
    FontBackgroundColor,
    Alignment,
    Link,
    List,
    TodoList,
    BlockQuote,
    Indent,
    IndentBlock,
    Table,
    TableToolbar,
    TableProperties,
    TableCellProperties,
    HorizontalLine,
    RemoveFormat,
    SpecialCharacters,
    SourceEditing,
    GeneralHtmlSupport,
    Undo
} from 'ckeditor5';

import { postOrgContactPersonSearch, postEmailTemplateRenderBody, getQuotationChangeStatus, postLeadsCreateProject, postSendQuotation, postShareDocument, postDocumentFileList, getLeadQuotation, postQuotationGenerate, getLeadDetails, postProductList, postCommunicationLogDropdown, postCommunicationLogHistory, postCommunicationLogSave, postLeads, postOrgClientSave, postLeadSave, postCommonMaster, postOrganizationDetail, getOrgClientDetailss, postOrgClientSaveReferences, postOrganizationProfile } from '../../apiservices/ApiServices';
import dayjs from 'dayjs';
import 'dayjs/locale/en';

const Leads = () => {
    const [isLoading, setLoading] = useState(false);
    const [isLoadings, setLoadings] = useState(false);
    const [data, setData] = useState([]);
    const [showLogModal, setShowLogModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [quotation, setQuotation] = useState(false);
    const [generateQuotation, setGenerateQuotation] = useState(false);
    const [documnetShared, setDcumnetShared] = useState(false);
    const [commonMaster, setCommonMaster] = useState([]);
    const [subSectorOptions, setSubSectorOptions] = useState([]);
    const [steps, setSteps] = useState(0);
    const [firstStp, setFirstStp] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [orgData, setOrgData] = useState([]);
    const [shows, setShows] = useState(false);
    const [fildsName, setFildsName] = useState('');
    const [addModal, setAddModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [deleteAddress, setDeleteAddress] = useState([]);
    const [deleteGst, setDeleteGst] = useState([]);
    const [deleteBank, setDeleteBank] = useState([]);
    const [deleteContact, setDeleteContact] = useState([]);
    const [addBank, setAddBank] = useState(false);
    const [addContactPerson, setAddContactPerson] = useState(false);
    const [addAddress, setAddAddress] = useState(false);
    const [addGst, setAddGst] = useState(false);
    const [addressList, setAddressList] = useState([]);
    const [bankList, setBankList] = useState([]);
    const [contactPersonList, setContactPersonList] = useState([]);
    const [gstList, setGstList] = useState([]);
    const [editAddress, setEditAddress] = useState(null);
    const [editGst, setEditGst] = useState(null);
    const [editBank, setEditBank] = useState(null);
    const [editContact, setEditContact] = useState(null);
    const [addressModal, setAddressModal] = useState(false);
    const [gstModal, setGstModal] = useState(false);
    const [bankModal, setBankModal] = useState(false);
    const [contactModal, setContactModal] = useState(false);
    const [dropdownList, setDropdownList] = useState([]);
    const [logHistory, setLogHistory] = useState([]);
    const [projectList, setProjectList] = useState([]);
    const [ids, setIds] = useState(2);
    const [clientList, setClientList] = useState([]);
    const [companyList, setCompanyList] = useState([]);
    const [quotationHistory, setQuotationHistory] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [leadInfoList, setLeadInfoList] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [ccselectedIds, setccSelectedIds] = useState([]);
    const [selectedDocument, setSelectedDocument] = useState([]);
    const [documentListData, setDocumentListData] = useState([]);
    const [mobilSearchList, setMobilSearchList] = useState([]);
    const [emailBody, setEmailBody] = useState('');

    const postLead = async (postData) => {
        setLoading(true);
        try {
            const res = await postLeads(postData);
            const formattedData = res?.data?.data?.records.map(item => ({
                id: item?.lead_id,
                clientId: item?.client?.client_id,
                LeadNo: item?.lead_no,
                leadDate: item?.lead_date,
                clientName: item?.client?.org_name,
                billingEntity: item?.billing_entity?.org_name,
                source: item?.source,
                project_category: item?.project_category?.proj_category_name,
                proj_category_id: item?.project_category?.proj_category_id,
                Fcount: item?.followup_count,
            }));
            setData(formattedData);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const postUpdates = async () => {
        let postData = {
            length: 100
        }
        setLoadings(true);
        try {
            const res = await postLeads(postData);
            const formattedData = res?.data?.data?.records.map(item => ({
                id: item?.lead_id,
                clientId: item?.client?.client_id,
                LeadNo: item?.lead_no,
                leadDate: item?.lead_date,
                clientName: item?.client?.org_name,
                billingEntity: item?.billing_entity?.org_name,
                source: item?.source,
                project_category: item?.project_category?.proj_category_name,
                proj_category_id: item?.project_category?.proj_category_id,
                Fcount: item?.followup_count,
            }));
            setData(formattedData);
            setLoadings(false);
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    useEffect(() => {
        let postData = {
            length: 100
        }
        postLead(postData);
    }, []);

    const columns = useMemo(
        () => [
            {
                Header: "Lead No.",
                accessor: "LeadNo",
            },
            {
                Header: "Lead Date",
                accessor: "leadDate",
            },
            {
                Header: "Client Name",
                accessor: "clientName",
            },
            {
                Header: "billing Entity",
                accessor: "billingEntity",
            },
            {
                Header: "Source",
                accessor: "source",
            },
            {
                Header: "project Category",
                accessor: "project_category",
            },
            {
                Header: "Followup Count",
                accessor: "Fcount",
            },
            {
                Header: "Action",
                accessor: "action",
                disableSortBy: true,
            },
        ],
        []
    );

    const addnew = async () => {
        formik.resetForm();
        setLoadings(true);
        let postData = {
            type: [
                "billing_entity",
                "channel_partner",
                "client_source",
                "employee_band",
                "revenue_band",
                "tax_structure",
                "broad_structure",
                "sector",
                "org_group",
                "organization",
                "function",
                "stages"
            ],
            org_type_code: ''
        }
        try {
            const res = await postCommonMaster(postData);
            setCommonMaster(res.data.data);
            setLoadings(false);
            setAddModal(true);
            setSteps(0);
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const actions = ['log', 'Documnet Shared', 'Generate Quotation', 'Send Quotation', 'edit', 'createProject']
    const subActions = []

    const emptyStatement = {
        clientId: '',
        leadId: '',
        orgNameId: '',
        orgName: '',
        orgGroupId: '',
        orgGroupName: '',
        displayName: '',
        pan: '',
        cin: '',
        revenueBand: '',
        employeeBand: '',
        orgStructureIncomeTax: '',
        orgBroadStructure: '',
        sectorId: '',
        subSectorids: [],
        engagementDate: '',
        incorporationDate: '',
        isActive: 0,
        isListed: 0,

        previousActuary: '',
        lastKnownNetworth: '',
        stage: '',


        addressId: '',
        gstId: '',
        bankId: '',
        contactId: '',

        isEmail: 0,

        billingEntityId: '',
        source: '',
        sourceLabel: '',
        sourceDescription: '',
        cpid: '',
        mid: '',
        fname: '',
        lname: '',
        mobile: '',
        email: '',
        remarks: '',


        interactionMode: '',
        interactionDate: '',
        interactionTime: '',
        contactPersonId: '',
        durationMinutes: '',
        statusId: '',
        nextFollowUpDate: '',
        notes: '',


        fromContactList: '',
        activityoutputTemplateId: '',

        isCompanyProfile: 0,
        isProducts: 0,
        quotationDate: dayjs().format('DD-MM-YYYY'),
        projCategoryId: '',
        products: {
            productCategory: '',
            productSubCategory: '',
            productId: '',
            regulatoryStandard: '',
            proStartDate: '',
            proEndDate: '',
            empCount: '',
            amounts: '',
        },
    };

    const [initialFormikValues, setInitialFormikValues] = useState({
        products: [emptyStatement]
    });

    const add = () => {
        setFieldValue('products', [...values.products, { ...emptyStatement }]);
    };

    const remove = (index) => {
        const updated = values.products.filter((_, i) => i !== index);
        setFieldValue('products', updated);
    };

    const formik = useFormik({
        initialValues: initialFormikValues,
        validationSchema: '',
        onSubmit: async (values) => {

            if (addModal) {
                setLoadings(true);
                let postData = {
                    "org_id": values.orgNameId,
                    "billing_entity_id": values.billingEntityId,
                    "org_name": values.orgName,
                    "org_group_id": values.orgGroupId,
                    "org_group_name": values.orgGroupName,
                    "display_name": values.displayName,
                    "source_type_id": values.source,
                    user_id: values.mid,
                    "source_description": values.sourceLabel == 'Channel Partner' ? values.cpid : values.sourceDescription,
                    "contact_person_first_name": values.fname,
                    "contact_person_last_name": values.lname,
                    "contact_person_email": values.email,
                    "contact_person_phone": values.mobile,
                    "remarks": values.remarks,
                }

                try {
                    const res = await postLeadSave(postData);
                    toast.success(res.data.message);
                    setAddModal(false);
                    formik.resetForm();
                    postUpdates();
                    setLoadings(false);
                } catch (error) {
                    setLoadings(false);
                    toast.error(error.response?.data?.message || "Error submitting data");
                }
            }

            if (editModal) {
                setLoadings(true);
                let postData = {
                    client_id: values.clientId || '',
                    org_id: values.orgNameId,
                    organization: {
                        org_name: values.orgName,
                        org_group_id: values.orgGroupId,
                        org_group_name: values.orgGroupName,
                        org_group_description: "",
                        display_name: values.displayName,
                        pan: values.pan || '',
                        cin: values.cin,
                        revenue_band_id: values.revenueBand,
                        employee_band_id: values.employeeBand,
                        income_tax_structure_id: values.orgStructureIncomeTax,
                        org_broad_structure_id: values.orgBroadStructure,
                        sector_id: values.sectorId,
                        sub_sector_ids: values.subSectorids || [],
                        engagement_date: values.engagementDate,
                        incorporation_date: values.incorporationDate,
                        is_active: values.isActive,
                        is_listed: values.isListed,
                    },
                    previous_actuary: values.previousActuary,
                    last_known_networth: values.lastKnownNetworth,
                    source_type_id: values.source,
                    source_description: values.sourceLabel == 'Channel Partner' ? values.cpid : values.sourceDescription,
                    stage_id: values.stage,
                    lead_id: values.leadId,
                    proj_category_id: values.projCategoryId,
                    lead_products: values.products.map((item) => ({
                        product_id: item?.productId,
                        category_id: item?.productCategory,
                        sub_category_id: item?.productSubCategory,
                        start_date: item?.proStartDate,
                        end_date: item?.proEndDate,
                        accounts_standard_id: item?.regulatoryStandard,
                        employee_count: item?.empCount,
                        amount: item?.amounts,
                    })),
                }

                try {
                    const res = await postOrgClientSave(postData);
                    toast.success(res.data.message);
                    setSteps(1);
                    setFirstStp(true);
                    setLoadings(false);

                    setFieldValue('id', res?.data?.data?.client_id || '');
                    setFieldValue('orgNameId', res?.data?.data?.org_id || '');
                    setFieldValue('orgGroupId', res?.data?.data?.org_group_id || '');
                    postUpdates();
                } catch (error) {
                    setLoadings(false);
                    toast.error(error.response?.data?.message || "Error submitting data");
                }
            }

            if (showLogModal) {
                setLoadings(true);
                let postData = {
                    entity_id: values.leadId,
                    log_type: 'lead',
                    interaction_mode: values.interactionMode,
                    interaction_date: values.interactionDate,
                    interaction_time: values.interactionTime,
                    contact_person_id: values.contactPersonId,
                    com_type_id: values.typeId,
                    notes: values.notes,
                    duration_minutes: values.durationMinutes,
                    status: values.statusId,
                    next_follow_up_date: values.nextFollowUpDate,
                }
                try {
                    const res = await postCommunicationLogSave(postData);
                    toast.success(res.data.message);
                    setLoadings(false);
                    setShowLogModal(false);

                } catch (error) {
                    setLoadings(false);
                    toast.error(error.response?.data?.message || "Error submitting data");
                }
            }

            if (generateQuotation) {
                setLoadings(true);
                let postData = {
                    lead_id: values.leadId,
                    quotation_date: values.quotationDate,
                    proj_category_id: values.projCategoryId,
                    products: values.products.map((item) => ({
                        product_id: item?.productId,
                        category_id: item?.productCategory,
                        sub_category_id: item?.productSubCategory,
                        start_date: item?.proStartDate,
                        end_date: item?.proEndDate,
                        accounts_standard_id: item?.regulatoryStandard,
                        employee_count: item?.empCount,
                        amount: item?.amounts,
                    })),
                }

                try {
                    const res = await postQuotationGenerate(postData);
                    toast.success(res.data.message);
                    getLeadQuotations(values.leadId);
                    setLoadings(false);
                } catch (error) {
                    setLoadings(false);
                    toast.error(error.response?.data?.message || "Error submitting data");
                }
            }

            if (documnetShared) {
                setLoadings(true);
                let postData = {
                    lead_id: values.leadId,
                    from_user_id: values.fromContactList,
                    to_user_ids: selectedIds,
                    cc_user_ids: ccselectedIds,
                    email_subject: values.subject,
                    email_body: emailBody,
                    document_file_ids: selectedDocument,
                    proj_category_id: values.projCategoryId,
                    products: values.products.map((item) => ({
                        product_id: item?.productId,
                        category_id: item?.productCategory,
                        sub_category_id: item?.productSubCategory,
                    })),
                }

                try {
                    const res = await postShareDocument(postData);
                    toast.success(res.data.message);
                    setDcumnetShared(false);
                    setLoadings(false);
                } catch (error) {
                    setLoadings(false);
                    toast.error(error.response?.data?.message || "Error submitting data");
                }
            }

            if (quotation) {
                setLoadings(true);
                let postData = {
                    lead_id: values.leadId,
                    from_user_id: values.fromContactList,
                    to_user_ids: selectedIds,
                    cc_user_ids: ccselectedIds,
                    email_subject: values.subject,
                    email_body: emailBody,
                    document_file_ids: selectedDocument,
                }

                try {
                    const res = await postSendQuotation(postData);
                    toast.success(res.data.message);
                    setQuotation(false);
                    setLoadings(false);
                } catch (error) {
                    setLoadings(false);
                    toast.error(error.response?.data?.message || "Error submitting data");
                }
            }
        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    const postOrgClientSaveReference = async () => {
        setLoadings(true);
        let postData = {
            client_id: values.clientId,
            ...(values.addressId && { address_id: values.addressId }),
            ...(values.gstId && { gst_id: values.gstId }),
            ...(values.bankId && { bank_account_id: values.bankId }),
            ...(values.contactId && { primary_contact_id: values.contactId })
        }

        try {
            const res = await postOrgClientSaveReferences(postData);
            toast.success(res.data.message);
            setAddModal(false);
            setEditModal(false);

            setAddressModal(false);
            setGstModal(false);
            setBankModal(false);
            setContactModal(false);

            setIds(null);


            setSteps(0);
            setFirstStp(false);
            setLoadings(false);

        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const postUpdateOrganizationProfiles = async () => {
        setLoadings(true);
        let postData = {
            id: values.orgNameId || ids,
        }
        try {
            const res = await postOrganizationProfile(postData);
            setAddressList(res.data.data.saved_address);
            setBankList(res.data.data.bank_accounts);
            setContactPersonList(res.data.data.contact_persons);
            setGstList(res.data.data.gst);
            setLoadings(false);
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message);
        }
    };

    useEffect(() => {
        if (values.sectorId) {
            const selectedSector = commonMaster?.sector.find(sector => sector.sector_id == values.sectorId);

            if (selectedSector && selectedSector.sub_sectors && selectedSector.sub_sectors.length > 0) {
                console.log(selectedSector.sub_sectors)
                setSubSectorOptions(selectedSector.sub_sectors);
            } else {
                setSubSectorOptions([]);
            }
        } else {
            setSubSectorOptions([]);
        }
    }, [values.sectorId]);

    const postOrganizationProfiles = async (postData) => {
        setLoadings(true);
        try {
            const res = await postOrganizationProfile(postData);
            setAddressList(res.data.data.saved_address);
            setBankList(res.data.data.bank_accounts);
            setContactPersonList(res.data.data.contact_persons);
            setGstList(res.data.data.gst);
            console.log(res.data.data)
            setLoadings(false);
            toast.success(res?.data?.message);
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message);
        }
    };

    useEffect(() => {
        if (steps == 1) {
            let postData = {
                id: values.orgNameId,
            }
            postOrganizationProfiles(postData);
        }
    }, [steps]);

    const postProductLists = async (id) => {
        setLoadings(true);
        let postData = {
            proj_category_id: id
        }
        try {
            const res = await postProductList(postData);
            setProjectList(res.data.data);
            setLoadings(false);
        } catch (error) {
            toast.error(error.response?.data?.message || "Error submitting data");
            setLoadings(false);
        }
    };

    const postRenderEmailBody = async (postData) => {
        setLoadings(true);
        setEmailBody('');
        setFieldValue('subject', '');
        try {
            const res = await postEmailTemplateRenderBody(postData);
            setEmailBody(res.data.data?.body || '');
            setFieldValue('subject', res.data.data?.subject);
            setLoadings(false);
        } catch (error) {
            setLoadings(false);
        }
    };

    const handleConfirm = () => {
        setAddModal(false);
        setEditModal(false);
        setQuotation(false);
        setDcumnetShared(false);
        setShowLogModal(false);
        setGenerateQuotation(false);
        postUpdates();
    };

    const handleEdit = async (rowData) => {
        formik.resetForm();
        setLoadings(true);
        let postData = {
            type: [
                "project_category",
                "billing_entity",
                "client_source",
                "employee_band",
                "revenue_band",
                "tax_structure",
                "broad_structure",
                "sector",
                "org_group",
                "organization",
                "function",
                "stages",
                "accounting_standards",
            ],
            org_type_code: 'CL'
        }
        try {
            const commonData = await postCommonMaster(postData);
            setCommonMaster(commonData.data.data);
            try {
                const res = await getOrgClientDetailss(rowData.clientId, rowData.id);

                setFieldValue('clientId', res.data.data?.client_id || '');
                setFieldValue('leadId', res.data.data?.lead_id || '');
                setFieldValue('orgNameId', res.data.data?.org_organization?.org_id || '');
                setFieldValue('orgName', res.data.data?.org_organization?.org_name || '');
                setFieldValue('displayName', res.data.data?.org_organization?.display_name || '');
                setFieldValue('orgGroupId', res.data.data?.org_organization?.org_group?.org_group_id || '');
                setFieldValue('orgGroupName', res.data.data?.org_organization?.org_group?.org_group_name || '');
                setFieldValue('pan', res.data.data?.org_organization?.pan || '');
                setFieldValue('cin', res.data.data?.org_organization?.cin || '');
                setFieldValue('revenueBand', res.data.data?.org_organization?.revenue_band?.id || '');
                setFieldValue('employeeBand', res.data.data?.org_organization?.employee_band?.id || '');
                setFieldValue('orgStructureIncomeTax', res.data.data?.org_organization?.income_tax_structure?.id || '');
                setFieldValue('orgBroadStructure', res.data.data?.org_organization?.broad_structure?.id || '');
                setFieldValue('sectorId', res.data.data?.org_organization?.sector?.sector_id || '');
                setFieldValue('subSectorids', res.data.data?.org_organization?.sub_sector_ids || []);
                setFieldValue('engagementDate', res.data.data?.org_organization?.engagement_date || '');
                setFieldValue('incorporationDate', res.data.data?.org_organization?.incorporation_date || '');
                setFieldValue('isActive', res.data.data?.org_organization?.is_listed ? 1 : 0);
                setFieldValue('isListed', res.data.data?.org_organization?.is_active ? 1 : 0);


                setFieldValue('source', res.data.data?.source_type?.id || '');
                setFieldValue('sourceLabel', res.data.data?.source_type?.name || '');
                setFieldValue('cpid', res.data.data?.source_description || '');
                setFieldValue('sourceDescription', res.data.data?.source_description || '');
                setFieldValue('previousActuary', res.data.data?.previous_actuary || '');
                setFieldValue('lastKnownNetworth', res.data.data?.last_known_networth || '');
                setFieldValue('stage', res.data.data?.stage?.stage_id || '');
                setFieldValue('projCategoryId', res.data.data?.proj_category_id || '');

                postProductLists(res.data.data?.proj_category_id);

                const leadProducts = res.data?.data?.lead_products || [];
                let formattedProducts;
                if (leadProducts.length > 0) {
                    formattedProducts = leadProducts.map(item => ({
                        productCategory: item.category_id || '',
                        productSubCategory: item.sub_category_id || '',
                        productId: item.product_id || '',
                        regulatoryStandard: item.accounts_standard_id || '',
                        proStartDate: item?.start_date || '',
                        proEndDate: item?.end_date || '',
                        empCount: item?.employee_count || '',
                        amounts: item?.amount || '',
                    }));
                } else {
                    formattedProducts = [{ ...emptyStatement }];
                }
                setFieldValue('products', formattedProducts);


                setFieldValue('addressId', res.data.data?.org_address?.address_id || '');
                setFieldValue('gstId', res.data.data?.org_gst?.gst_id || '');
                setFieldValue('bankId', res.data.data?.org_bank?.bank_account_id || '');
                setFieldValue('contactId', res.data.data?.org_contact_person?.primary_contact_id || '');

                setSteps(0);
                setEditModal(true);
                setLoadings(false);
            } catch (error) {
                setLoadings(false);
                toast.error(error.response?.data?.message || "Error submitting data");
            }


        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }

    };

    const handleLog = async (rowData) => {
        formik.resetForm();
        let postData = {
            entity_id: rowData?.id,
            log_type: "lead"
        }

        try {
            const res = await postCommunicationLogDropdown(postData);
            setDropdownList(res.data.data);
            setFieldValue('leadId', rowData?.id);
            try {
                const res = await postCommunicationLogHistory(postData);
                setLogHistory(res.data.data);
                setLoadings(false);

            } catch (error) {
                setLoadings(false);
                toast.error(error.response?.data?.message || "Error submitting data");
            }
            setShowLogModal(true);
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }

    };

    const getLeadQuotations = async (id) => {
        setLoadings(false);
        try {
            const res = await getLeadQuotation(id);
            setQuotationHistory(res.data.data);
            setLoadings(false);
        } catch (error) {
            toast.error(error.response?.data?.message || "Error submitting data");
            setLoadings(false);
        }
    };

    const handleGenerateQuotation = async (rowData) => {
        formik.resetForm();
        setQuotationHistory([]);
        setLoadings(true);
        try {
            let postData = {
                type: [
                    "project_category",
                    "billing_entity",
                    "client_source",
                    "employee_band",
                    "revenue_band",
                    "tax_structure",
                    "broad_structure",
                    "sector",
                    "org_group",
                    "organization",
                    "function",
                    "stages",
                    "accounting_standards",
                ],
                org_type_code: 'CL'
            }
            const commonData = await postCommonMaster(postData);
            setCommonMaster(commonData.data.data);
            try {
                const res = await getLeadDetails(rowData.id);
                setFieldValue('leadId', res.data.data?.lead_id || '');
                setFieldValue('projCategoryId', res.data?.data?.project_category?.proj_category_id);
                postProductLists(res.data?.data?.project_category?.proj_category_id);

                const leadProducts = res.data?.data?.products || [];
                let formattedProducts;
                if (leadProducts.length > 0) {
                    formattedProducts = leadProducts.map(item => ({
                        productCategory: item?.category?.category_id || '',
                        productSubCategory: item?.sub_category?.sub_category_id || '',
                        productId: item?.product?.product_id || '',
                        regulatoryStandard: item?.accounts_standard?.id || '',
                        proStartDate: item?.start_date || '',
                        proEndDate: item?.end_date || '',
                        empCount: item?.employee_count || '',
                        amounts: item?.amount || '',
                    }));
                } else {
                    formattedProducts = [{ ...emptyStatement }];
                }
                setFieldValue('products', formattedProducts);
                getLeadQuotations(res.data?.data?.lead_id);
                setLoadings(false);
                setGenerateQuotation(true);
            } catch (error) {
                setLoadings(false);
                toast.error(error.response?.data?.message || "Error submitting data");
            }

        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const handleCreateProject = async (rowData) => {
        setLoadings(false);

        let postData = {
            lead_id: rowData?.id
        }
        try {
            const res = await postLeadsCreateProject(postData);
            toast.success(res.data.message);
            postUpdates();
            setLoadings(false);
        } catch (error) {
            toast.error(error.response?.data?.message || "Error submitting data");
            setLoadings(false);
        }
    };

    const postDocumentFileLists = async (postData) => {
        setLoadings(false);
        try {
            const res = await postDocumentFileList(postData);
            setDocumentListData(res.data.data);
            setLoadings(false);
        } catch (error) {
            toast.error(error.response?.data?.message || "Error submitting data");
            setLoadings(false);
        }
    };

    useEffect(() => {
        if (documnetShared || quotation) {
            setLoadings(false);
            const productIdList = values?.products?.map(product => product.productId);
            let postData = {
                billing_entity_id: leadInfoList?.billing_entity?.billing_entity_id,
                product_ids: productIdList,
                email_template_id: values?.activityoutputTemplateId
            }
            postDocumentFileLists(postData);

        }
    }, [values?.activityoutputTemplateId, values?.products]);

    const handleonDocumnetShared = async (rowData) => {
        formik.resetForm();

        setLeadInfoList([]);
        setSelectedIds([]);
        setccSelectedIds([]);
        setSelectedDocument([]);
        setDocumentListData([]);
        setEmailBody('');
        setLoadings(true);
        try {
            let postData = {
                type: [
                    "project_category",
                    "billing_entity",
                    "accounting_standards",
                ],
                org_type_code: ''
            }
            const commonData = await postCommonMaster(postData);
            setCommonMaster(commonData.data.data);
            try {
                const res = await getLeadDetails(rowData.id);
                setFieldValue('leadId', res.data?.data?.lead_id);
                setFieldValue('projCategoryId', res.data?.data?.project_category?.proj_category_id);
                setLeadInfoList(res.data?.data);

                if (res.data?.data?.project_category?.proj_category_id != null) {
                    postProductLists(res.data?.data?.project_category?.proj_category_id);
                }


                const leadProducts = res.data?.data?.products || [];
                let formattedProducts;
                if (leadProducts.length > 0) {
                    formattedProducts = leadProducts.map(item => ({
                        productCategory: item?.category?.category_id || '',
                        productSubCategory: item?.sub_category?.sub_category_id || '',
                        productId: item?.product?.product_id || '',
                        regulatoryStandard: item?.accounts_standard?.id || '',
                        proStartDate: item?.start_date || '',
                        proEndDate: item?.end_date || '',
                        empCount: item?.employee_count || '',
                        amounts: item?.amount || '',
                    }));
                } else {
                    formattedProducts = [{ ...emptyStatement }];
                }
                setFieldValue('products', formattedProducts);
                setLoadings(false);
                setDcumnetShared(true);
            } catch (error) {
                setLoadings(false);
                toast.error(error.response?.data?.message || "Error submitting data");
            }

        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const handleQuotation = async (rowData) => {
        formik.resetForm();
        setEmailBody('');
        setLeadInfoList([]);
        setSelectedIds([]);
        setccSelectedIds([]);
        setSelectedDocument([]);
        setDocumentListData([]);

        setLoadings(true);

        try {
            const res = await getLeadDetails(rowData.id);
            setFieldValue('leadId', res.data?.data?.lead_id);
            setLeadInfoList(res.data?.data);
            let postDatas = {
                billing_entity_id: res.data?.data?.billing_entity?.billing_entity_id,
            }
            postDocumentFileLists(postDatas);
            setLoadings(false);
            setQuotation(true);
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }

    };

    const handleSwitchToggle = async (id, leadId) => {
        setLoadings(true);
        try {
            const res = await getQuotationChangeStatus(id);
            toast.success(res.data.message);
            getLeadQuotations(values.leadId);
            setLoadings(false);
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }

    };

    const getFilteredSubCategories = (categoryId) => {
        if (!categoryId || !projectList?.sub_category_list) return [];
        return projectList.sub_category_list
            .filter((sub) => sub.parent_category_id === parseInt(categoryId))
            .map((sub) => ({ id: sub.category_id, name: sub.category_name }));
    };

    const getFilteredProducts = (subCategoryId) => {
        if (!subCategoryId || !projectList?.product_list) return [];
        return projectList.product_list
            .filter((prod) => prod.sub_category_id === parseInt(subCategoryId))
            .map((prod) => ({ id: prod.product_id, name: prod.product_name }));
    };

    useEffect(() => {
        if (documnetShared || quotation) {
            setLoadings(false);
            const productIdList = values?.products?.map(product => product.productId);
            let postData = {
                lead_id: values.leadId,
                product_ids: productIdList,
                email_template_id: values?.activityoutputTemplateId,
                from_person_id: values?.fromContactList,
                document_file_ids: selectedDocument
            }
            postRenderEmailBody(postData);

        }
    }, [values?.activityoutputTemplateId, values?.products, values?.fromContactList, selectedDocument]);

    const postOrgContactPersonSearchs = async (postData) => {
        setLoadings(true);
        try {
            const res = await postOrgContactPersonSearch(postData);
            setMobilSearchList(res.data.data);
            setLoadings(false);
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    useEffect(() => {
        if (values?.mobile && values.mobile.length == 5) {
            const postData = {
                search_text: values.mobile
            };
            postOrgContactPersonSearchs(postData);
        }
    }, [values.mobile]);

    return (
        <>
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />

            {isLoading ? <Loader /> :
                <>
                    <PageTitle titles="Leads" active="Leads" items={['Home']} />
                    <Row>
                        <Col sm={12} className="col-12">
                            <Card>
                                <Card.Body className="example1-table">
                                    <div className='custompageHed'>
                                        <Row>
                                            <Col md={6}>
                                                <div className='pagetitle_hed'>
                                                    <h1>Leads</h1>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className='w-100 d-flex justify-content-end'>
                                                    <button type='button' className='btn btn-primary' onClick={() => addnew()}>Add New</button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <Tables
                                        columns={columns}
                                        data={data}
                                        actions={actions}
                                        subActions={subActions}
                                        onLog={handleLog}
                                        onEdit={handleEdit}
                                        onGenerateQuotation={handleGenerateQuotation}
                                        onQuotation={handleQuotation}
                                        onDocumnetShared={handleonDocumnetShared}
                                        onCreateProject={handleCreateProject}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            }

            <Modals
                show={addModal}
                handleClose={() => setAddModal(false)}
                title={editModal ? 'Edit Lead' : 'Add New Lead'}
                textColor='#000'
                size='lg'
                centered={true}
                backdrop={true}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={4}>
                            <div className="form-group">
                                <Autocomplete
                                    name="orgName"
                                    label="Org Name"
                                    suggestions={commonMaster?.organization || []}
                                    placeholder="Type to search organizations..."
                                    value={values.orgName}
                                    displayField="org_name"
                                    valueField="org_id"
                                    onChange={(fieldName, value) => {
                                        if (typeof value === 'object') {
                                            setFieldValue('orgNameId', value.org_id);
                                            setFieldValue('orgName', value.org_name);
                                        } else {
                                            setFieldValue('orgNameId', '');
                                            setFieldValue('orgName', '');
                                            setFieldValue(fieldName, value);
                                        }
                                    }}
                                    onBlur={handleBlur}
                                    error={errors.orgName}
                                    touched={touched.orgName}
                                />
                                {errors.orgName && touched.orgName && (
                                    <p className="errormsg">{errors.orgName}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <Autocomplete
                                    name="orgGroupName"
                                    label="Org Group Name"
                                    suggestions={commonMaster?.org_group || []}
                                    placeholder="Type to search Org. Group..."
                                    value={values.orgGroupName}
                                    displayField="org_group_name"
                                    valueField="org_group_id"
                                    onChange={(fieldName, value) => {
                                        if (typeof value === 'object') {
                                            setFieldValue('orgGroupId', value.org_group_id);
                                            setFieldValue('orgGroupName', value.org_group_name);
                                        } else {
                                            setFieldValue(fieldName, value);
                                        }
                                    }}
                                    onBlur={handleBlur}
                                    error={errors.orgName}
                                    touched={touched.orgName}
                                />
                                {errors.orgName && touched.orgName && (
                                    <p className="errormsg">{errors.orgName}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Org Display Name</label>
                                <input
                                    type='text'
                                    id="displayName"
                                    name="displayName"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.displayName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.displayName && touched.displayName && (
                                    <p className="errormsg">{errors.displayName}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Select Billing Entity</label>
                                <SelectFild
                                    Firstop='Select Billing Entity'
                                    selectName="billingEntityId"
                                    options={commonMaster?.billing_entity}
                                    value={values.billingEntityId}
                                    onChange={(selectedOption) => setFieldValue("billingEntityId", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                                {errors.billingEntityId && touched.billingEntityId && (
                                    <p className="errormsg">{errors.billingEntityId}</p>
                                )}
                            </div>
                        </Col>

                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Client Source</label>
                                <SelectFild
                                    Firstop='Select Source'
                                    selectName="source"
                                    options={commonMaster?.client_source}
                                    value={values.source}
                                    onChange={(selectedOption) => {
                                        setFieldValue("source", selectedOption?.value || "");
                                        setFieldValue("sourceLabel", selectedOption?.label || "");
                                    }}
                                    onBlur={handleBlur}
                                />
                                {errors.source && touched.source && (
                                    <p className="errormsg">{errors.source}</p>
                                )}
                            </div>
                        </Col>
                        {values.sourceLabel == 'Channel Partner' && (
                            <Col md={4}>
                                <div className="form-group">
                                    <label className="form-label">Select CP</label>
                                    <SelectFild
                                        Firstop='Select Channel Partner'
                                        selectName="cpid"
                                        options={commonMaster?.channel_partner}
                                        value={values.cpid}
                                        onChange={(selectedOption) => setFieldValue("cpid", selectedOption?.value || "")}
                                        onBlur={handleBlur}
                                    />
                                    {errors.cpid && touched.cpid && (
                                        <p className="errormsg">{errors.cpid}</p>
                                    )}
                                </div>
                            </Col>
                        )}
                        {values.sourceLabel == 'Website' && (
                            <Col md={4}>
                                <div className="form-group">
                                    <label className="form-label">Website Url</label>
                                    <input
                                        type='text'
                                        id="sourceDescription"
                                        name="sourceDescription"
                                        className="form-control"
                                        autoComplete='off'
                                        value={values.sourceDescription}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {errors.sourceDescription && touched.sourceDescription && (
                                        <p className="errormsg">{errors.sourceDescription}</p>
                                    )}
                                </div>
                            </Col>
                        )}
                        {values.sourceLabel == 'Referral' && (
                            <Col md={4}>
                                <div className="form-group">
                                    <label className="form-label">Referral Name</label>
                                    <input
                                        type='text'
                                        id="sourceDescription"
                                        name="sourceDescription"
                                        className="form-control"
                                        autoComplete='off'
                                        value={values.sourceDescription}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {errors.sourceDescription && touched.sourceDescription && (
                                        <p className="errormsg">{errors.sourceDescription}</p>
                                    )}
                                </div>
                            </Col>
                        )}
                    </Row>

                    <div className='fieldsets'>
                        <div className='fieldsets-title'>Contact Person</div>
                        <div className='formsboxs'>
                            <Row>
                                <Col md={6}>
                                    <div className="form-group">
                                        <AutoCompleteMobile
                                            name="mobile"
                                            label="Mobile Number"
                                            suggestions={mobilSearchList || []}
                                            placeholder="Type to search Mobile Number..."
                                            value={values.mobile}
                                            displayField="mobile_number"
                                            valueField="user_id"
                                            onChange={(fieldName, value) => {
                                                if (typeof value === 'object') {
                                                    setFieldValue('mid', value.user_id);
                                                    setFieldValue('mobile', value.mobile_number);
                                                    setFieldValue('fname', value.first_name);
                                                    setFieldValue('lname', value.last_name);
                                                    setFieldValue('email', value.email);
                                                } else {
                                                    setFieldValue('mid', '');
                                                    setFieldValue('mobile', '');
                                                    setFieldValue('fname', '');
                                                    setFieldValue('lastName', '');
                                                    setFieldValue('email', '');
                                                    setFieldValue(fieldName, value);
                                                }
                                            }}
                                            onBlur={handleBlur}
                                            error={errors.mobile}
                                            touched={touched.mobile}
                                        />
                                        {errors.mobile && touched.mobile && (
                                            <p className="errormsg">{errors.mobile}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label className="form-label">First Name</label>
                                        <input
                                            type='text'
                                            id="fname"
                                            name="fname"
                                            className="form-control"
                                            autoComplete='off'
                                            value={values.fname}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {errors.fname && touched.fname && (
                                            <p className="errormsg">{errors.fname}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label className="form-label">Last Name</label>
                                        <input
                                            type='text'
                                            id="lname"
                                            name="lname"
                                            className="form-control"
                                            autoComplete='off'
                                            value={values.lname}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {errors.lname && touched.lname && (
                                            <p className="errormsg">{errors.lname}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label className="form-label">Email Id</label>
                                        <input
                                            type='email'
                                            id="email"
                                            name="email"
                                            className="form-control"
                                            autoComplete='off'
                                            value={values.email}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {errors.email && touched.email && (
                                            <p className="errormsg">{errors.email}</p>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="form-label">Remarks</label>
                        <textarea
                            type='text'
                            id="remarks"
                            name="remarks"
                            className="form-control"
                            autoComplete='off'
                            value={values.remarks}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                        {errors.remarks && touched.remarks && (
                            <p className="errormsg">{errors.remarks}</p>
                        )}
                    </div>

                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Save</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            <Modal
                show={editModal}
                size={'xl'}
                centered={true}
                backdrop={true}
            >
                <div className="modal-header">
                    <div className="modal-title h4" style={{ color: "#000" }}>Edit Client</div>
                    <button onClick={() => { setEditModal(false); setEditAddress(null); }} type="button" className="btn-close" aria-label="Close"></button>
                </div>
                <Modal.Body>
                    <form id='step0' onSubmit={handleSubmit} autoComplete="off">
                        <div className='steps' style={{ display: steps == 0 ? 'block' : 'none' }}>
                            <div className='fieldsets cols_5'>
                                <div className='fieldsets-title'>General Information</div>
                                <Row>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <Autocomplete
                                                name="orgName"
                                                label="Org Name"
                                                suggestions={commonMaster?.organization || []}
                                                placeholder="Type to search organizations..."
                                                value={values.orgName}
                                                displayField="org_name"
                                                valueField="org_id"
                                                onChange={(fieldName, value) => {
                                                    if (typeof value === 'object') {
                                                        setFieldValue('orgNameId', value.org_id);
                                                        setFieldValue('orgName', value.org_name);
                                                    } else {
                                                        setFieldValue('orgNameId', '');
                                                        setFieldValue('orgName', '');
                                                        setFieldValue(fieldName, value);
                                                    }
                                                }}
                                                onBlur={handleBlur}
                                                error={errors.orgName}
                                                touched={touched.orgName}
                                            />
                                            {errors.orgName && touched.orgName && (
                                                <p className="errormsg">{errors.orgName}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <Autocomplete
                                                name="orgGroupName"
                                                label="Org Group Name"
                                                suggestions={commonMaster?.org_group || []}
                                                placeholder="Type to search Org. Group..."
                                                value={values.orgGroupName}
                                                displayField="org_group_name"
                                                valueField="org_group_id"
                                                onChange={(fieldName, value) => {
                                                    if (typeof value === 'object') {
                                                        setFieldValue('orgGroupId', value.org_group_id);
                                                        setFieldValue('orgGroupName', value.org_group_name);
                                                    } else {
                                                        setFieldValue(fieldName, value);
                                                    }
                                                }}
                                                onBlur={handleBlur}
                                                error={errors.orgName}
                                                touched={touched.orgName}
                                            />
                                            {errors.orgName && touched.orgName && (
                                                <p className="errormsg">{errors.orgName}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org Display Name</label>
                                            <input
                                                type='text'
                                                id="displayName"
                                                name="displayName"
                                                className="form-control"
                                                autoComplete='off'
                                                value={values.displayName}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            {errors.displayName && touched.displayName && (
                                                <p className="errormsg">{errors.displayName}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org pan.</label>
                                            <input
                                                type='text'
                                                id="pan"
                                                name="pan"
                                                className="form-control"
                                                autoComplete='off'
                                                value={values.pan}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            {errors.pan && touched.pan && (
                                                <p className="errormsg">{errors.pan}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org CIN No.</label>
                                            <input
                                                type='text'
                                                id="cin"
                                                name="cin"
                                                className="form-control"
                                                autoComplete='off'
                                                value={values.cin}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            {errors.cin && touched.cin && (
                                                <p className="errormsg">{errors.cin}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org Revenue Band</label>
                                            <SelectFild
                                                Firstop='Select Org Revenue Band'
                                                selectName="revenueBand"
                                                options={commonMaster?.revenue_band}
                                                value={values.revenueBand}
                                                onChange={(selectedOption) => setFieldValue("revenueBand", selectedOption?.value || "")}
                                                onBlur={handleBlur}
                                            />
                                            {errors.revenueBand && touched.revenueBand && (
                                                <p className="errormsg">{errors.revenueBand}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org Employee Band</label>
                                            <SelectFild
                                                Firstop='Select Org Employee Band'
                                                selectName="employeeBand"
                                                options={commonMaster?.employee_band}
                                                value={values.employeeBand}
                                                onChange={(selectedOption) => setFieldValue("employeeBand", selectedOption?.value || "")}
                                                onBlur={handleBlur}
                                            />
                                            {errors.employeeBand && touched.employeeBand && (
                                                <p className="errormsg">{errors.employeeBand}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org Structure Income Tax</label>
                                            <SelectFild
                                                Firstop='Select Org Structure Income Tax'
                                                selectName="orgStructureIncomeTax"
                                                options={commonMaster?.tax_structure}
                                                value={values.orgStructureIncomeTax}
                                                onChange={(selectedOption) => setFieldValue("orgStructureIncomeTax", selectedOption?.value || "")}
                                                onBlur={handleBlur}
                                            />
                                            {errors.orgStructureIncomeTax && touched.orgStructureIncomeTax && (
                                                <p className="errormsg">{errors.orgStructureIncomeTax}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org Broad Structure</label>
                                            <SelectFild
                                                Firstop='Select Org Broad Structure'
                                                selectName="orgBroadStructure"
                                                options={commonMaster?.broad_structure}
                                                value={values.orgBroadStructure}
                                                onChange={(selectedOption) => setFieldValue("orgBroadStructure", selectedOption?.value || "")}
                                                onBlur={handleBlur}
                                            />
                                            {errors.orgBroadStructure && touched.orgBroadStructure && (
                                                <p className="errormsg">{errors.orgBroadStructure}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org Sector</label>
                                            <SelectFild
                                                Firstop='Select Sector'
                                                selectName="sectorId"
                                                options={commonMaster?.sector}
                                                value={values.sectorId}
                                                onChange={(selectedOption) => setFieldValue("sectorId", selectedOption?.value || "")}
                                                onBlur={handleBlur}
                                            />
                                            {errors.sectorId && touched.sectorId && (
                                                <p className="errormsg">{errors.sectorId}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Org Sub Sector</label>
                                            <SelectFild
                                                Firstop='Select Sub Sector'
                                                selectName="subSectorids"
                                                options={subSectorOptions}
                                                value={values.subSectorids}
                                                onChange={(selectedOptions) => {
                                                    const selectedValues = selectedOptions ?
                                                        Array.isArray(selectedOptions) ?
                                                            selectedOptions.map(option => option.value) :
                                                            selectedOptions.value :
                                                        [];
                                                    setFieldValue('subSectorids', selectedValues);
                                                }}
                                                onBlur={handleBlur}
                                                isMulti={true}
                                            />
                                            {errors.subSectorids && touched.subSectorids && (
                                                <p className="errormsg">{errors.subSectorids}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Engagement Date</label>
                                            <DateFild
                                                value={values.engagementDate}
                                                onChange={(date) => setFieldValue('engagementDate', date)}
                                            />
                                            {errors.engagementDate && touched.engagementDate && (
                                                <p className="errormsg">{errors.engagementDate}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Incorporation Date</label>
                                            <DateFild
                                                value={values.incorporationDate}
                                                onChange={(date) => setFieldValue('incorporationDate', date)}
                                            />
                                            {errors.incorporationDate && touched.incorporationDate && (
                                                <p className="errormsg">{errors.incorporationDate}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className='d-flex align-items-center'>
                                            <div className="form-group w-50">
                                                <div className='d-flex align-items-center' style={{ marginTop: 30 }}>
                                                    <label className="form-label">Is Active</label>
                                                    <div className="switchs" style={{ marginLeft: 10 }}>
                                                        <input
                                                            type="checkbox"
                                                            id='isActive'
                                                            name='isActive'
                                                            className="form-control"
                                                            autoComplete='off'
                                                            checked={values.isActive === 1}
                                                            onChange={(e) => {
                                                                setFieldValue(
                                                                    'isActive',
                                                                    e.target.checked ? 1 : 0
                                                                );
                                                            }}
                                                            onBlur={handleBlur}
                                                        />
                                                        <span className="slider round"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group w-50">
                                                <div className='d-flex align-items-center' style={{ marginTop: 30 }}>
                                                    <label className="form-label">Is Listed</label>
                                                    <div className="switchs" style={{ marginLeft: 10 }}>
                                                        <input
                                                            type="checkbox"
                                                            id='isListed'
                                                            name='isListed'
                                                            className="form-control"
                                                            autoComplete='off'
                                                            checked={values.isListed === 1}
                                                            onChange={(e) => {
                                                                setFieldValue(
                                                                    'isListed',
                                                                    e.target.checked ? 1 : 0
                                                                );
                                                            }}
                                                            onBlur={handleBlur}
                                                        />
                                                        <span className="slider round"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>

                            <div className='fieldsets'>
                                <div className='fieldsets-title'>Products</div>
                                <div className="form-group">
                                    <label className="form-label">Select Project Category</label>
                                    <SelectFild
                                        Firstop='Select Project Category'
                                        selectName="projCategoryId"
                                        options={commonMaster?.project_category}
                                        value={values.projCategoryId}
                                        onChange={(selectedOption) => {
                                            postProductLists(selectedOption?.value);
                                            setFieldValue('projCategoryId', selectedOption?.value || "");
                                        }}
                                        onBlur={handleBlur}
                                    />
                                    {errors.projCategoryId && touched.projCategoryId && (
                                        <p className="errormsg">{errors.projCategoryId}</p>
                                    )}
                                </div>
                                {values.projCategoryId != '' && <>
                                    {values?.products.map((products, index) => (
                                        <div key={index} className="fieldsets mainFS">
                                            <div className='fieldsetsboxs'>
                                                <h6>Product {index + 1}</h6>
                                                <div className="addreovebtns">
                                                    <button type="button" className="btn add-btn" onClick={add}>+</button>
                                                    {values?.products?.length > 1 && (
                                                        <button type="button" className="btn remove-btn" onClick={() => remove(index)}>-</button>
                                                    )}
                                                </div>
                                            </div>
                                            <div className='formsBox'>
                                                <Row>
                                                    <Col md={3}>
                                                        <div className="form-group">
                                                            <label className="form-label">Product Category</label>
                                                            <SelectFild
                                                                Firstop='Select'
                                                                selectName={`products[${index}].productCategory`}
                                                                options={(projectList?.category_list || []).map((cat) => ({
                                                                    id: cat.category_id,
                                                                    name: cat.category_name,
                                                                }))}
                                                                value={products.productCategory}
                                                                onChange={(selectedOption) => setFieldValue(`products[${index}].productCategory`, selectedOption?.value || "")}
                                                                onBlur={() => handleBlur(`products[${index}].productCategory`)}
                                                            />
                                                            {errors.products && errors.products[index]?.productCategory && touched.products && touched.products[index]?.productCategory && (
                                                                <p className="errormsg">{errors.products[index].productCategory}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={3}>
                                                        <div className="form-group">
                                                            <label className="form-label">Product Sub Category</label>
                                                            <SelectFild
                                                                Firstop="Select"
                                                                selectName={`products[${index}].productSubCategory`}
                                                                options={getFilteredSubCategories(products.productCategory)}
                                                                value={products.productSubCategory}
                                                                onChange={(selectedOption) => {
                                                                    setFieldValue(`products[${index}].productSubCategory`, selectedOption?.value || '');
                                                                    setFieldValue(`products[${index}].productId`, '');
                                                                }}
                                                                onBlur={() => handleBlur(`products[${index}].productSubCategory`)}
                                                            />
                                                            {errors.products?.[index]?.productSubCategory &&
                                                                touched.products?.[index]?.productSubCategory && (
                                                                    <p className="errormsg">{errors.products[index].productSubCategory}</p>
                                                                )}
                                                        </div>
                                                    </Col>
                                                    <Col md={3}>
                                                        <div className="form-group">
                                                            <label className="form-label">Select Product</label>
                                                            <SelectFild
                                                                Firstop="Select"
                                                                selectName={`products[${index}].productId`}
                                                                options={getFilteredProducts(products.productSubCategory)}
                                                                value={products.productId}
                                                                onChange={(selectedOption) =>
                                                                    setFieldValue(`products[${index}].productId`, selectedOption?.value || '')
                                                                }
                                                                onBlur={() => handleBlur(`products[${index}].productId`)}
                                                            />
                                                            {errors.products?.[index]?.productId &&
                                                                touched.products?.[index]?.productId && (
                                                                    <p className="errormsg">{errors.products[index].productId}</p>
                                                                )}
                                                        </div>
                                                    </Col>
                                                    <Col md={3}>
                                                        <div className="form-group">
                                                            <label className="form-label">Start Date</label>
                                                            <DateFild
                                                                value={products.proStartDate}
                                                                onChange={(date) => setFieldValue(`products[${index}].proStartDate`, date)}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col md={3}>
                                                        <div className="form-group">
                                                            <label className="form-label">End Date</label>
                                                            <DateFild
                                                                value={products.proEndDate}
                                                                onChange={(date) => setFieldValue(`products[${index}].proEndDate`, date)}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col md={3}>
                                                        <div className="form-group">
                                                            <label className="form-label">Regulatory Applicable Standard</label>
                                                            <SelectFild
                                                                Firstop="Select"
                                                                selectName={`products[${index}].regulatoryStandard`}
                                                                options={commonMaster?.accounting_standards}
                                                                value={products.regulatoryStandard}
                                                                onChange={(selectedOption) =>
                                                                    setFieldValue(`products[${index}].regulatoryStandard`, selectedOption?.value || '')
                                                                }
                                                                onBlur={() => handleBlur(`products[${index}].regulatoryStandard`)}
                                                            />
                                                            {errors.products?.[index]?.regulatoryStandard &&
                                                                touched.products?.[index]?.regulatoryStandard && (
                                                                    <p className="errormsg">{errors.products[index].regulatoryStandard}</p>
                                                                )}
                                                        </div>
                                                    </Col>
                                                    <Col md={3}>
                                                        <div className="form-group">
                                                            <label className="form-label">Employee Count</label>
                                                            <input
                                                                type='text'
                                                                name={`products[${index}].empCount`}
                                                                className="form-control"
                                                                autoComplete='off'
                                                                value={products.empCount}
                                                                onChange={(e) => setFieldValue(`products[${index}].empCount`, e.target.value)}
                                                            />
                                                            {errors.products && errors.products[index]?.empCount && touched.products && touched.products[index]?.empCount && (
                                                                <p className="errormsg">{errors.products[index].empCount}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={3}>
                                                        <div className="form-group">
                                                            <label className="form-label">Amount</label>
                                                            <input
                                                                type='text'
                                                                name={`products[${index}].amounts`}
                                                                className="form-control"
                                                                autoComplete='off'
                                                                value={products.amounts}
                                                                onChange={(e) => setFieldValue(`products[${index}].amounts`, e.target.value)}
                                                            />
                                                            {errors.products && errors.products[index]?.amounts && touched.products && touched.products[index]?.amounts && (
                                                                <p className="errormsg">{errors.products[index].amounts}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    ))}
                                </>}
                            </div>

                            <div className='fieldsets cols_5'>
                                <div className='fieldsets-title'>Client Information</div>
                                <Row>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Client Source</label>
                                            <SelectFild
                                                Firstop='Select Source'
                                                selectName="source"
                                                options={commonMaster?.client_source}
                                                value={values.source}
                                                onChange={(selectedOption) => {
                                                    setFieldValue("source", selectedOption?.value || "");
                                                    setFieldValue("sourceLabel", selectedOption?.label || "");
                                                }}
                                                onBlur={handleBlur}
                                            />
                                            {errors.source && touched.source && (
                                                <p className="errormsg">{errors.source}</p>
                                            )}
                                        </div>
                                    </Col>
                                    {values.sourceLabel == 'Channel Partner' && (
                                        <Col md={4}>
                                            <div className="form-group">
                                                <label className="form-label">Select CP</label>
                                                <SelectFild
                                                    Firstop='Select Channel Partner'
                                                    selectName="cpid"
                                                    options={commonMaster?.channel_partner}
                                                    value={values.cpid}
                                                    onChange={(selectedOption) => setFieldValue("cpid", selectedOption?.value || "")}
                                                    onBlur={handleBlur}
                                                />
                                                {errors.cpid && touched.cpid && (
                                                    <p className="errormsg">{errors.cpid}</p>
                                                )}
                                            </div>
                                        </Col>
                                    )}
                                    {values.sourceLabel == 'Website' && (
                                        <Col md={4}>
                                            <div className="form-group">
                                                <label className="form-label">Website Url</label>
                                                <input
                                                    type='text'
                                                    id="sourceDescription"
                                                    name="sourceDescription"
                                                    className="form-control"
                                                    autoComplete='off'
                                                    value={values.sourceDescription}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                {errors.sourceDescription && touched.sourceDescription && (
                                                    <p className="errormsg">{errors.sourceDescription}</p>
                                                )}
                                            </div>
                                        </Col>
                                    )}
                                    {values.sourceLabel == 'Referral' && (
                                        <Col md={4}>
                                            <div className="form-group">
                                                <label className="form-label">Referral Name</label>
                                                <input
                                                    type='text'
                                                    id="sourceDescription"
                                                    name="sourceDescription"
                                                    className="form-control"
                                                    autoComplete='off'
                                                    value={values.sourceDescription}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                {errors.sourceDescription && touched.sourceDescription && (
                                                    <p className="errormsg">{errors.sourceDescription}</p>
                                                )}
                                            </div>
                                        </Col>
                                    )}
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Previous Actuary</label>
                                            <input
                                                type='text'
                                                id="previousActuary"
                                                name="previousActuary"
                                                className="form-control"
                                                autoComplete='off'
                                                value={values.previousActuary}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            {errors.previousActuary && touched.previousActuary && (
                                                <p className="errormsg">{errors.previousActuary}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="form-group">
                                            <label className="form-label">Last Known Networth</label>
                                            <input
                                                type='text'
                                                id="lastKnownNetworth"
                                                name="lastKnownNetworth"
                                                className="form-control"
                                                autoComplete='off'
                                                value={values.lastKnownNetworth}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            {errors.lastKnownNetworth && touched.lastKnownNetworth && (
                                                <p className="errormsg">{errors.lastKnownNetworth}</p>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="form-group">
                                            <label className="form-label">Stage</label>
                                            <div className='stagesbox'>
                                                <ul>
                                                    {commonMaster?.stages?.map((item) => (
                                                        <li key={`Stage_${item?.stage_id}`}>
                                                            <div className='stage' style={{ backgroundColor: item?.stage_color }}>
                                                                <input
                                                                    type="radio"
                                                                    name="stage"
                                                                    value={item?.stage_id}
                                                                    checked={values.stage == item?.stage_id}
                                                                    onChange={(e) => {
                                                                        setFieldValue(
                                                                            'stage',
                                                                            e.target.checked ? item?.stage_id : ''
                                                                        );
                                                                    }}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <div className='chkmarksbox'></div>
                                                                <p>{item?.stage_name}</p>
                                                            </div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                            {errors.stage && touched.stage && (
                                                <p className="errormsg">{errors.stage}</p>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </div>

                            <div className='modalfooters'>
                                <div className='button-boxs grid'>
                                    <button type='submit' className='btn btn-primary'>update & Next</button>
                                    <button type='button' onClick={() => setSteps(1)} className='btn btn-btn btn-default'>Next</button>
                                    <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                                </div>
                            </div>
                        </div>
                    </form>

                    <div className='steps' style={{ display: steps == 1 ? 'block' : 'none' }}>
                        <div className='fieldsets'>
                            <div className='fieldsetsboxs'>
                                <h6>Address</h6>
                                <div onClick={() => setAddAddress(!addAddress)} className='btnlinks'>+ Add New</div>
                            </div>

                            <div className='banksbox'>
                                {addAddress &&
                                    <Address
                                        orgId={values.orgNameId}
                                        toast={toast}
                                        postUpdateOrganizationProfiles={postUpdateOrganizationProfiles}
                                        setAddAddress={setAddAddress}
                                        setEditAddress={setEditAddress}
                                        editAddress={editAddress}
                                    />
                                }
                                <div className='addressCardsbox'>
                                    <Row>
                                        {addressList.map((item, index) => (
                                            <Col md={4} key={`address${item?.address_id}`}>
                                                <div className='addressCard'>
                                                    <div className='addresshed'>
                                                        <input
                                                            type="radio"
                                                            name="address"
                                                            value={item?.address_id}
                                                            checked={item?.address_id == values.addressId}
                                                            onChange={() =>
                                                                setFieldValue('addressId', item?.address_id)
                                                            }
                                                        />
                                                        <div className='btns'>
                                                            <button onClick={() => { setAddAddress(true); setEditAddress(item); }}>
                                                                <FaEdit />
                                                            </button>
                                                            <button onClick={() => { setShows(true); setFildsName('address'); setDeleteAddress(item); }}>
                                                                <FaTrashAlt />
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className='addrestype'>
                                                        <FaLandmark /><span>{item?.address_type}</span>
                                                    </div>
                                                    <p>{item?.address_line1} {item?.area}, {item?.city}, {item?.pincodes?.state_name},{item?.pincodes?.pincode}, {item?.pincodes?.country_name}</p>
                                                </div>
                                            </Col>
                                        ))}
                                    </Row>
                                </div>
                            </div>
                        </div>

                        <div className='fieldsets'>
                            <div className='fieldsetsboxs'>
                                <h6>GST</h6>
                                <div onClick={() => setAddGst(!addGst)} className='btnlinks'>+ Add New</div>
                            </div>
                            <div className='banksbox'>
                                {addGst &&
                                    <Gst
                                        orgId={values.orgNameId}
                                        toast={toast}
                                        postUpdateOrganizationProfiles={postUpdateOrganizationProfiles}
                                        setAddGst={setAddGst}
                                        setEditGst={setEditGst}
                                        editGst={editGst}
                                        addressList={addressList}
                                    />
                                }
                                <div className="table-responsive">
                                    <table className="table table-bordered text-nowrap mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{ width: 60 }}></th>
                                                <th>Gst In</th>
                                                <th>Legal Name</th>
                                                <th>Trade Name</th>
                                                <th>Pan</th>
                                                <th>Registration Date</th>
                                                <th className='txt-center' style={{ width: 80 }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {gstList.map((item) => (
                                                <tr
                                                    key={`gst${item?.gst_id}`}
                                                    className={item?.gst_id === values.gstId ? 'active' : ''}
                                                >
                                                    <td className='rdotd'>
                                                        <input
                                                            type="radio"
                                                            name="gst"
                                                            value={item?.gst_id}
                                                            checked={item?.gst_id == values.gstId}
                                                            onChange={() =>
                                                                setFieldValue('gstId', item?.gst_id)
                                                            }
                                                        />
                                                    </td>
                                                    <td>{item?.gstin}</td>
                                                    <td>{item?.legal_name}</td>
                                                    <td>{item?.trade_name}</td>
                                                    <td>{item?.pan}</td>
                                                    <td style={{ textAlign: 'left !important' }}>{item?.registration_date}</td>
                                                    <td>
                                                        <div className="d-flex justify-content-center gap-2">
                                                            <button className='btn-action edit' onClick={() => { setAddGst(true); setEditGst(item); }}>
                                                                <FaEdit />
                                                            </button>
                                                            <button className='btn-action delete' onClick={() => { setShows(true); setFildsName('gst'); setDeleteGst(item); }}>
                                                                <FaTrashAlt />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div className='fieldsets'>
                            <div className='fieldsetsboxs'>
                                <h6>Banks Information</h6>
                                <div onClick={() => setAddBank(!addBank)} className='btnlinks'>+ Add New</div>
                            </div>
                            <div className='fieldsets-title'>Banks Information</div>
                            <div className='banksbox'>
                                {addBank &&
                                    <BankInfo
                                        orgId={values.orgNameId}
                                        toast={toast}
                                        postUpdateOrganizationProfiles={postUpdateOrganizationProfiles}
                                        setAddBank={setAddBank}
                                        setEditBank={setEditBank}
                                        editBank={editBank}
                                    />
                                }
                                <div className="table-responsive">
                                    <table className="table table-bordered text-nowrap mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{ width: 60 }}></th>
                                                <th>Bank Name</th>
                                                <th>Branch Name</th>
                                                <th>Account Number</th>
                                                <th>Beneficiary Name</th>
                                                <th>IFSC Code</th>
                                                <th>MICR Code</th>
                                                <th>Swift Code</th>
                                                <th>Account Type Code</th>
                                                <th className='txt-center' style={{ width: 80 }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {bankList.map((item) => (
                                                <tr
                                                    key={`banks${item?.bank_account_id}`}
                                                    className={item?.bank_account_id === values.bankId ? 'active' : ''}
                                                >
                                                    <td className='rdotd'>
                                                        <input
                                                            type="radio"
                                                            name="banks"
                                                            value={item?.bank_account_id}
                                                            checked={item?.bank_account_id == values.bankId}
                                                            onChange={() =>
                                                                setFieldValue('bankId', item?.bank_account_id)
                                                            }
                                                        />
                                                    </td>
                                                    <td>{item?.bank_name}</td>
                                                    <td>{item?.bank_branch_name}</td>
                                                    <td>{item?.account_number}</td>
                                                    <td>{item?.beneficiary_name}</td>
                                                    <td>{item?.bank_ifsc_code}</td>
                                                    <td>{item?.bank_micr_code}</td>
                                                    <td>{item?.bank_swift_code}</td>
                                                    <td>{item?.account_type_code}</td>
                                                    <td>
                                                        <div className="d-flex justify-content-center gap-2">
                                                            <button className='btn-action edit' onClick={() => { setAddBank(true); setEditBank(item); }}>
                                                                <FaEdit />
                                                            </button>
                                                            <button className='btn-action delete' onClick={() => { setShows(true); setFildsName('bank'); setDeleteBank(item); }}>
                                                                <FaTrashAlt />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div className='fieldsets'>
                            <div className='fieldsetsboxs'>
                                <h6>Contact Person</h6>
                                <div onClick={() => setAddContactPerson(!addContactPerson)} className='btnlinks'>+ Add New</div>
                            </div>
                            <div className='banksbox'>
                                {addContactPerson &&
                                    <ContactPerson
                                        orgId={values.orgNameId}
                                        toast={toast}
                                        postUpdateOrganizationProfiles={postUpdateOrganizationProfiles}
                                        setAddContactPerson={setAddContactPerson}
                                        setEditContact={setEditContact}
                                        editContact={editContact}
                                        functionList={commonMaster?.function}
                                        orgTypeCode='CL'
                                    />
                                }
                                <div className="table-responsive">
                                    <table className="table table-bordered text-nowrap mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{ width: 60 }}></th>
                                                <th>First Name</th>
                                                <th>Last Name</th>
                                                <th>Email Id</th>
                                                <th>Mobile Number</th>
                                                <th>Function</th>
                                                <th>Designation</th>
                                                <th className='txt-center' style={{ width: 80 }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {contactPersonList.map((item, index) => (
                                                <tr
                                                    key={`contactPerson${item?.contact_person_id}`}
                                                    className={item?.contact_person_id === values.contactId ? 'active' : ''}
                                                >
                                                    <td className='rdotd'>
                                                        <input
                                                            type="radio"
                                                            name="contactPerson"
                                                            value={item?.contact_person_id}
                                                            checked={item?.contact_person_id == values.contactId}
                                                            onChange={() =>
                                                                setFieldValue('contactId', item?.contact_person_id)
                                                            }
                                                        />
                                                    </td>
                                                    <td>{item?.first_name}</td>
                                                    <td>{item?.last_name}</td>
                                                    <td>{item?.email}</td>
                                                    <td>{item?.mobile_number}</td>
                                                    <td>{item?.function?.name}</td>
                                                    <td>{item?.designation?.name}</td>
                                                    <td>
                                                        <div className="d-flex justify-content-center gap-2">
                                                            <button className='btn-action edit' onClick={() => { setAddContactPerson(true); setEditContact(item); }}>
                                                                <FaEdit />
                                                            </button>
                                                            <button className='btn-action delete' onClick={() => { setShows(true); setFildsName('contact'); setDeleteContact(item); }}>
                                                                <FaTrashAlt />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div className='modalfooters'>
                            <div className='button-boxs grid'>
                                <button type='button' onClick={() => setSteps(0)} className='btn btn-default'>Prev</button>
                                <button type='button' onClick={() => postOrgClientSaveReference()} className='btn btn-primary'>Submit</button>
                                <button type='button' onClick={handleConfirm} className='btn btn-default'>Closed</button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modals
                show={documnetShared}
                handleClose={() => setDcumnetShared(false)}
                title="Documnet Shared"
                textColor='#000'
                size='xl'
                centered={true}
                backdrop={true}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">From</label>
                                <div className="table-responsive">
                                    <table className="table table-bordered text-nowrap mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{ width: 60 }}></th>
                                                <th style={{ width: 350 }}>First Name</th>
                                                <th style={{ width: 350 }}>Last Name</th>
                                                <th>Email Id</th>
                                                <th style={{ width: 350 }} className="txt-left">Mobile Number</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {leadInfoList?.billing_entity_person?.map((item) => (
                                                <tr key={`tab_content_person_${item?.user_id}`}>
                                                    <td className='rdotd'>
                                                        <input
                                                            type="radio"
                                                            name="fromContactList"
                                                            value={item?.user_id}
                                                            checked={values.fromContactList == item?.user_id}
                                                            onChange={(e) => { setFieldValue('fromContactList', e.target.checked ? item?.user_id : ''); }}
                                                            onBlur={handleBlur}
                                                        />
                                                    </td>
                                                    <td>{item?.first_name}</td>
                                                    <td>{item?.last_name}</td>
                                                    <td>{item?.email}</td>
                                                    <td>{item?.mobile_number}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">To</label>
                                <div className="table-responsive">
                                    <table className="table table-bordered text-nowrap mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{ width: 60 }}></th>
                                                <th style={{ width: 350 }}>First Name</th>
                                                <th style={{ width: 350 }}>Last Name</th>
                                                <th>Email Id</th>
                                                <th style={{ width: 350 }} className="txt-left">Mobile Number</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {leadInfoList?.client_person?.map((item) => (
                                                <tr key={`tab_content_person_${item?.user_id}`}>
                                                    <td className='rdotd'>
                                                        <input
                                                            type="checkbox"
                                                            value={item.user_id}
                                                            checked={selectedIds.includes(item.user_id)}
                                                            onChange={(e) => {
                                                                const id = item.user_id;
                                                                setSelectedIds(prev =>
                                                                    e.target.checked
                                                                        ? [...prev, id]
                                                                        : prev.filter(pid => pid !== id)
                                                                );
                                                            }}
                                                        />
                                                    </td>
                                                    <td>{item?.first_name}</td>
                                                    <td>{item?.last_name}</td>
                                                    <td>{item?.email}</td>
                                                    <td>{item?.mobile_number}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">CC</label>
                                <div className="table-responsive">
                                    <table className="table table-bordered text-nowrap mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{ width: 60 }}></th>
                                                <th style={{ width: 350 }}>First Name</th>
                                                <th style={{ width: 350 }}>Last Name</th>
                                                <th>Email Id</th>
                                                <th style={{ width: 350 }} className="txt-left">Mobile Number</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {leadInfoList?.billing_entity_person?.map((item) => (
                                                <tr key={`tab_content_person_${item?.user_id}`}>
                                                    <td className='rdotd'>
                                                        <input
                                                            type="checkbox"
                                                            value={item.user_id}
                                                            checked={ccselectedIds.includes(item.user_id)}
                                                            onChange={(e) => {
                                                                const id = item.user_id;
                                                                setccSelectedIds(prev =>
                                                                    e.target.checked
                                                                        ? [...prev, id]
                                                                        : prev.filter(pid => pid !== id)
                                                                );
                                                            }}
                                                        />
                                                    </td>
                                                    <td>{item?.first_name}</td>
                                                    <td>{item?.last_name}</td>
                                                    <td>{item?.email}</td>
                                                    <td>{item?.mobile_number}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Select Email Template</label>
                                <SelectFild
                                    Firstop='Select Email Template'
                                    selectName="activityoutputTemplateId"
                                    options={leadInfoList?.email_template}
                                    value={values.activityoutputTemplateId}
                                    onChange={(selectedOption) => {
                                        setFieldValue('activityoutputTemplateId', selectedOption?.value || "");
                                    }}
                                    onBlur={handleBlur}
                                />
                                {errors.activityoutputTemplateId && touched.activityoutputTemplateId && (
                                    <p className="errormsg">{errors.activityoutputTemplateId}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Subject</label>
                                <input
                                    type='text'
                                    id="subject"
                                    name="subject"
                                    className="form-control"
                                    value={values.subject}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.subject && touched.subject && (
                                    <p className="errormsg">{errors.subject}</p>
                                )}
                            </div>
                        </Col>

                        {/* <Col md={2}>
                            <div className="form-group">
                                <div className='d-flex align-items-center' style={{ marginTop: 30 }}>
                                    <label className="form-label">is Company Profile</label>
                                    <div className="switchs" style={{ marginLeft: 10 }}>
                                        <input
                                            type="checkbox"
                                            name="products[0].isCompanyProfile"
                                            className="form-control"
                                            checked={values.products?.[0]?.isCompanyProfile === 1}
                                            onChange={(e) =>
                                                setFieldValue('products[0].isCompanyProfile', e.target.checked ? 1 : 0)
                                            }
                                            onBlur={handleBlur}
                                        />
                                        <span className="slider round"></span>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col md={2}>
                            <div className="form-group">
                                <div className='d-flex align-items-center' style={{ marginTop: 30 }}>
                                    <label className="form-label">is Products</label>
                                    <div className="switchs" style={{ marginLeft: 10 }}>
                                        <input
                                            type="checkbox"
                                            name="products[0].isProducts"
                                            className="form-control"
                                            checked={values.products?.[0]?.isProducts === 1}
                                            onChange={(e) =>
                                                setFieldValue('products[0].isProducts', e.target.checked ? 1 : 0)
                                            }
                                            onBlur={handleBlur}
                                        />
                                        <span className="slider round"></span>
                                    </div>
                                </div>
                            </div>
                        </Col> */}
                        <Col md={12}>
                            <div className='fieldsets'>
                                <div className='fieldsets-title'>Products</div>
                                <div className="form-group">
                                    <label className="form-label">Select Project Category</label>
                                    <SelectFild
                                        Firstop='Select Project Category'
                                        selectName="projCategoryId"
                                        options={commonMaster?.project_category}
                                        value={values.projCategoryId}
                                        onChange={(selectedOption) => {
                                            postProductLists(selectedOption?.value);
                                            setFieldValue('projCategoryId', selectedOption?.value || "");
                                        }}
                                        onBlur={handleBlur}
                                    />
                                    {errors.projCategoryId && touched.projCategoryId && (
                                        <p className="errormsg">{errors.projCategoryId}</p>
                                    )}
                                </div>
                                {values.projCategoryId != '' && <>
                                    {values?.products.map((products, index) => (
                                        <div key={index} className="fieldsets mainFS">
                                            <div className='fieldsetsboxs'>
                                                <h6>Product {index + 1}</h6>
                                                <div className="addreovebtns">
                                                    <button type="button" className="btn add-btn" onClick={add}>+</button>
                                                    {values?.products?.length > 1 && (
                                                        <button type="button" className="btn remove-btn" onClick={() => remove(index)}>-</button>
                                                    )}
                                                </div>
                                            </div>
                                            <div className='formsBox'>
                                                <Row>
                                                    <Col md={4}>
                                                        <div className="form-group">
                                                            <label className="form-label">Product Category</label>
                                                            <SelectFild
                                                                Firstop='Select'
                                                                selectName={`products[${index}].productCategory`}
                                                                options={(projectList?.category_list || []).map((cat) => ({
                                                                    id: cat.category_id,
                                                                    name: cat.category_name,
                                                                }))}
                                                                value={products.productCategory}
                                                                onChange={(selectedOption) => setFieldValue(`products[${index}].productCategory`, selectedOption?.value || "")}
                                                                onBlur={() => handleBlur(`products[${index}].productCategory`)}
                                                            />
                                                            {errors.products && errors.products[index]?.productCategory && touched.products && touched.products[index]?.productCategory && (
                                                                <p className="errormsg">{errors.products[index].productCategory}</p>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md={4}>
                                                        <div className="form-group">
                                                            <label className="form-label">Product Sub Category</label>
                                                            <SelectFild
                                                                Firstop="Select"
                                                                selectName={`products[${index}].productSubCategory`}
                                                                options={getFilteredSubCategories(products.productCategory)}
                                                                value={products.productSubCategory}
                                                                onChange={(selectedOption) => {
                                                                    setFieldValue(`products[${index}].productSubCategory`, selectedOption?.value || '');
                                                                    setFieldValue(`products[${index}].productId`, '');
                                                                }}
                                                                onBlur={() => handleBlur(`products[${index}].productSubCategory`)}
                                                            />
                                                            {errors.products?.[index]?.productSubCategory &&
                                                                touched.products?.[index]?.productSubCategory && (
                                                                    <p className="errormsg">{errors.products[index].productSubCategory}</p>
                                                                )}
                                                        </div>
                                                    </Col>
                                                    <Col md={4}>
                                                        <div className="form-group">
                                                            <label className="form-label">Select Product</label>
                                                            <SelectFild
                                                                Firstop="Select"
                                                                selectName={`products[${index}].productId`}
                                                                options={getFilteredProducts(products.productSubCategory)}
                                                                value={products.productId}
                                                                onChange={(selectedOption) =>
                                                                    setFieldValue(`products[${index}].productId`, selectedOption?.value || '')
                                                                }
                                                                onBlur={() => handleBlur(`products[${index}].productId`)}
                                                            />
                                                            {errors.products?.[index]?.productId &&
                                                                touched.products?.[index]?.productId && (
                                                                    <p className="errormsg">{errors.products[index].productId}</p>
                                                                )}
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    ))}
                                </>}
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Email Body</label>
                                <CKEditor
                                    editor={ClassicEditor}
                                    data={emailBody}
                                    config={{
                                        licenseKey: 'GPL',
                                        plugins: [
                                            Essentials,
                                            Paragraph,
                                            Heading,
                                            Bold,
                                            Italic,
                                            Underline,
                                            Strikethrough,
                                            Code,
                                            Subscript,
                                            Superscript,
                                            Font,
                                            FontFamily,
                                            FontSize,
                                            FontColor,
                                            FontBackgroundColor,
                                            Alignment,
                                            Link,
                                            List,
                                            TodoList,
                                            BlockQuote,
                                            Indent,
                                            IndentBlock,
                                            Table,
                                            TableToolbar,
                                            TableProperties,
                                            TableCellProperties,
                                            HorizontalLine,
                                            RemoveFormat,
                                            SpecialCharacters,
                                            SourceEditing,
                                            GeneralHtmlSupport
                                        ],

                                        toolbar: [
                                            'undo', 'redo',
                                            '|',
                                            'heading',
                                            '|',
                                            'fontFamily',
                                            'fontSize',
                                            'fontColor',
                                            'fontBackgroundColor',
                                            '|',
                                            'bold',
                                            'italic',
                                            'underline',
                                            'strikethrough',
                                            '|',
                                            'alignment',
                                            '|',
                                            'bulletedList',
                                            'numberedList',
                                            'todoList',
                                            '|',
                                            'outdent',
                                            'indent',
                                            '|',
                                            'link',
                                            'insertTable',
                                            '|',
                                            'blockQuote',
                                            'horizontalLine',
                                            'removeFormat',
                                            '|',
                                            'sourceEditing'
                                        ],

                                        table: {
                                            contentToolbar: [
                                                'tableColumn',
                                                'tableRow',
                                                'mergeTableCells',
                                                'tableProperties',
                                                'tableCellProperties'
                                            ]
                                        },

                                        htmlSupport: {
                                            allow: [
                                                {
                                                    name: /.*/,
                                                    attributes: true,
                                                    classes: true,
                                                    styles: true
                                                }
                                            ]
                                        }
                                    }}
                                    onChange={(event, editor) => {
                                        const data = editor.getData();
                                        setEmailBody(data);
                                    }}
                                    onReady={(editor) => {
                                        console.log('Editor is ready to use!', editor);
                                    }}
                                    onBlur={(event, editor) => {
                                        console.log('Blur.', editor);
                                    }}
                                    onFocus={(event, editor) => {
                                        console.log('Focus.', editor);
                                    }}
                                />
                            </div>
                        </Col>
                        {documentListData?.common_document?.length > 0 && (
                            <Col md={12}>
                                <div className='fieldsets'>
                                    <div className='fieldsets-title'>Common Document</div>
                                    <div className='attachmentsList'>
                                        <ul>
                                            {documentListData?.common_document?.map((item) => (
                                                <li>
                                                    <div className='listcards'>
                                                        <h4>{item?.document_title}</h4>
                                                        <ul>
                                                            {item?.files?.map((files) => (
                                                                <li>
                                                                    <div className='attBox'>
                                                                        <div className="chkBox">
                                                                            <input
                                                                                type="checkbox"
                                                                                value={files.document_file_id}
                                                                                checked={selectedDocument.includes(files.document_file_id)}
                                                                                onChange={(e) => {
                                                                                    const id = files.document_file_id;
                                                                                    setSelectedDocument(prev =>
                                                                                        e.target.checked
                                                                                            ? [...prev, id]
                                                                                            : prev.filter(pid => pid !== id)
                                                                                    );
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <div className="pdf-icon">
                                                                            <FaFilePdf size={16} color="#e74c3c" />
                                                                        </div>
                                                                        <p>{files?.file_name}</p>
                                                                        <a href={files?.file_url} target="_blank" className='btn btn-primary' rel="noopener noreferrer"><FaEye /></a>
                                                                    </div>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </Col>
                        )}

                        {documentListData?.product_document?.length > 0 && (
                            <Col md={12}>
                                <div className='fieldsets'>
                                    <div className='fieldsets-title'>Common Document</div>
                                    <div className='attachmentsList'>
                                        <ul>
                                            {documentListData?.product_document?.map((item) => (
                                                <li>
                                                    <div className='listcards'>
                                                        <h4>{item?.document_title}</h4>
                                                        <ul>
                                                            {item?.files?.map((files) => (
                                                                <li>
                                                                    <div className='attBox'>
                                                                        <div className="chkBox">
                                                                            <input
                                                                                type="checkbox"
                                                                                value={files.document_file_id}
                                                                                checked={selectedDocument.includes(files.document_file_id)}
                                                                                onChange={(e) => {
                                                                                    const id = files.document_file_id;
                                                                                    setSelectedDocument(prev =>
                                                                                        e.target.checked
                                                                                            ? [...prev, id]
                                                                                            : prev.filter(pid => pid !== id)
                                                                                    );
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <div className="pdf-icon">
                                                                            <FaFilePdf size={16} color="#e74c3c" />
                                                                        </div>
                                                                        <p>{files?.file_name}</p>
                                                                        <a href={files?.file_url} target="_blank" className='btn btn-primary' rel="noopener noreferrer"><FaEye /></a>
                                                                    </div>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </Col>
                        )}
                        {documentListData?.email_document?.length > 0 && (
                            <Col md={12}>
                                <div className='fieldsets'>
                                    <div className='fieldsets-title'>Common Document</div>
                                    <div className='attachmentsList'>
                                        <ul>
                                            {documentListData?.email_document?.map((item) => (
                                                <li>
                                                    <div className='listcards'>
                                                        <h4>{item?.document_title}</h4>
                                                        <ul>
                                                            {item?.files?.map((files) => (
                                                                <li>
                                                                    <div className='attBox'>
                                                                        <div className="chkBox">
                                                                            <input
                                                                                type="checkbox"
                                                                                value={files.document_file_id}
                                                                                checked={selectedDocument.includes(files.document_file_id)}
                                                                                onChange={(e) => {
                                                                                    const id = files.document_file_id;
                                                                                    setSelectedDocument(prev =>
                                                                                        e.target.checked
                                                                                            ? [...prev, id]
                                                                                            : prev.filter(pid => pid !== id)
                                                                                    );
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <div className="pdf-icon">
                                                                            <FaFilePdf size={16} color="#e74c3c" />
                                                                        </div>
                                                                        <p>{files?.file_name}</p>
                                                                        <a href={files?.file_url} target="_blank" className='btn btn-primary' rel="noopener noreferrer"><FaEye /></a>
                                                                    </div>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </Col>
                        )}
                    </Row>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Send</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            <Modals
                show={generateQuotation}
                handleClose={() => setGenerateQuotation(false)}
                title="Generate Quotation"
                textColor='#000'
                size='xl'
                centered={true}
                backdrop={true}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    {quotationHistory && quotationHistory.length > 0 && (
                        <div className='fieldsets'>
                            <div className='fieldsets-title'>Quotation History</div>
                            <table className="table table-bordered text-nowrap mb-0">
                                <thead>
                                    <tr>
                                        <th>Quotation No.</th>
                                        <th>Quotation Version</th>
                                        <th>Quotation Date</th>
                                        <th>Quotation Amount</th>
                                        <th>is Approved</th>
                                        <th width={150}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {quotationHistory.map((item, index) => (
                                        <tr>
                                            <td>{item?.quotation_no}</td>
                                            <td>{item?.version_no}</td>
                                            <td>{item?.quotation_date}</td>
                                            <td>{item?.amount}</td>
                                            <td>
                                                <div className="switchs">
                                                    <input
                                                        type="checkbox"
                                                        checked={item?.is_approved}
                                                        onChange={() => handleSwitchToggle(item?.quotation_version_id)}
                                                    />
                                                    <span className="slider round"></span>
                                                </div>
                                            </td>
                                            <td><a href={item?.quotation_file} target="_blank" className='btn btn-primary' rel="noopener noreferrer">View Pdf</a></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    <div className='fieldsets'>
                        <div className='fieldsets-title'>New Quotation</div>
                        <Row>
                            <Col md={6}>
                                <div className="form-group">
                                    <label className="form-label">Quotation Date</label>
                                    <DateFild
                                        value={values.quotationDate}
                                        onChange={(date) => setFieldValue('quotationDate', date)}
                                    />
                                    {errors.quotationDate && touched.quotationDate && (
                                        <p className="errormsg">{errors.quotationDate}</p>
                                    )}
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="form-group">
                                    <label className="form-label">Select Project Category</label>
                                    <SelectFild
                                        Firstop='Select Project Category'
                                        selectName="projCategoryId"
                                        options={commonMaster?.project_category}
                                        value={values.projCategoryId}
                                        onChange={(selectedOption) => {
                                            postProductLists(selectedOption?.value);
                                            setFieldValue('projCategoryId', selectedOption?.value || "");
                                        }}
                                        onBlur={handleBlur}
                                    />
                                    {errors.projCategoryId && touched.projCategoryId && (
                                        <p className="errormsg">{errors.projCategoryId}</p>
                                    )}
                                </div>
                            </Col>
                        </Row>

                        {values.projCategoryId != '' && <>
                            {values?.products.map((products, index) => (
                                <div key={index} className="fieldsets mainFS">
                                    <div className='fieldsetsboxs'>
                                        <h6>Product {index + 1}</h6>
                                        <div className="addreovebtns">
                                            <button type="button" className="btn add-btn" onClick={add}>+</button>
                                            {values?.products?.length > 1 && (
                                                <button type="button" className="btn remove-btn" onClick={() => remove(index)}>-</button>
                                            )}
                                        </div>
                                    </div>
                                    <div className='formsBox'>
                                        <Row>
                                            <Col md={3}>
                                                <div className="form-group">
                                                    <label className="form-label">Product Category</label>
                                                    <SelectFild
                                                        Firstop='Select'
                                                        selectName={`products[${index}].productCategory`}
                                                        options={(projectList?.category_list || []).map((cat) => ({
                                                            id: cat.category_id,
                                                            name: cat.category_name,
                                                        }))}
                                                        value={products.productCategory}
                                                        onChange={(selectedOption) => setFieldValue(`products[${index}].productCategory`, selectedOption?.value || "")}
                                                        onBlur={() => handleBlur(`products[${index}].productCategory`)}
                                                    />
                                                    {errors.products && errors.products[index]?.productCategory && touched.products && touched.products[index]?.productCategory && (
                                                        <p className="errormsg">{errors.products[index].productCategory}</p>
                                                    )}
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div className="form-group">
                                                    <label className="form-label">Product Sub Category</label>
                                                    <SelectFild
                                                        Firstop="Select"
                                                        selectName={`products[${index}].productSubCategory`}
                                                        options={getFilteredSubCategories(products.productCategory)}
                                                        value={products.productSubCategory}
                                                        onChange={(selectedOption) => {
                                                            setFieldValue(`products[${index}].productSubCategory`, selectedOption?.value || '');
                                                            setFieldValue(`products[${index}].productId`, '');
                                                        }}
                                                        onBlur={() => handleBlur(`products[${index}].productSubCategory`)}
                                                    />
                                                    {errors.products?.[index]?.productSubCategory &&
                                                        touched.products?.[index]?.productSubCategory && (
                                                            <p className="errormsg">{errors.products[index].productSubCategory}</p>
                                                        )}
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div className="form-group">
                                                    <label className="form-label">Select Product</label>
                                                    <SelectFild
                                                        Firstop="Select"
                                                        selectName={`products[${index}].productId`}
                                                        options={getFilteredProducts(products.productSubCategory)}
                                                        value={products.productId}
                                                        onChange={(selectedOption) =>
                                                            setFieldValue(`products[${index}].productId`, selectedOption?.value || '')
                                                        }
                                                        onBlur={() => handleBlur(`products[${index}].productId`)}
                                                    />
                                                    {errors.products?.[index]?.productId &&
                                                        touched.products?.[index]?.productId && (
                                                            <p className="errormsg">{errors.products[index].productId}</p>
                                                        )}
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div className="form-group">
                                                    <label className="form-label">Start Date</label>
                                                    <DateFild
                                                        value={products.proStartDate}
                                                        onChange={(date) => setFieldValue(`products[${index}].proStartDate`, date)}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div className="form-group">
                                                    <label className="form-label">End Date</label>
                                                    <DateFild
                                                        value={products.proEndDate}
                                                        onChange={(date) => setFieldValue(`products[${index}].proEndDate`, date)}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div className="form-group">
                                                    <label className="form-label">Regulatory Applicable Standard</label>
                                                    <SelectFild
                                                        Firstop="Select"
                                                        selectName={`products[${index}].regulatoryStandard`}
                                                        options={commonMaster?.accounting_standards}
                                                        value={products.regulatoryStandard}
                                                        onChange={(selectedOption) =>
                                                            setFieldValue(`products[${index}].regulatoryStandard`, selectedOption?.value || '')
                                                        }
                                                        onBlur={() => handleBlur(`products[${index}].regulatoryStandard`)}
                                                    />
                                                    {errors.products?.[index]?.regulatoryStandard &&
                                                        touched.products?.[index]?.regulatoryStandard && (
                                                            <p className="errormsg">{errors.products[index].regulatoryStandard}</p>
                                                        )}
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div className="form-group">
                                                    <label className="form-label">Employee Count</label>
                                                    <input
                                                        type='text'
                                                        name={`products[${index}].empCount`}
                                                        className="form-control"
                                                        autoComplete='off'
                                                        value={products.empCount}
                                                        onChange={(e) => setFieldValue(`products[${index}].empCount`, e.target.value)}
                                                    />
                                                    {errors.products && errors.products[index]?.empCount && touched.products && touched.products[index]?.empCount && (
                                                        <p className="errormsg">{errors.products[index].empCount}</p>
                                                    )}
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div className="form-group">
                                                    <label className="form-label">Amount</label>
                                                    <input
                                                        type='text'
                                                        name={`products[${index}].amounts`}
                                                        className="form-control"
                                                        autoComplete='off'
                                                        value={products.amounts}
                                                        onChange={(e) => setFieldValue(`products[${index}].amounts`, e.target.value)}
                                                    />
                                                    {errors.products && errors.products[index]?.amounts && touched.products && touched.products[index]?.amounts && (
                                                        <p className="errormsg">{errors.products[index].amounts}</p>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            ))}
                        </>}
                    </div>

                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Generate Quotation</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            <Modals
                show={quotation}
                handleClose={() => setQuotation(false)}
                title="Send Quotation"
                textColor='#000'
                size='xl'
                centered={true}
                backdrop={true}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">From</label>
                                <div className="table-responsive">
                                    <table className="table table-bordered text-nowrap mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{ width: 60 }}></th>
                                                <th style={{ width: 350 }}>First Name</th>
                                                <th style={{ width: 350 }}>Last Name</th>
                                                <th>Email Id</th>
                                                <th style={{ width: 350 }} className="txt-left">Mobile Number</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {leadInfoList?.billing_entity_person?.map((item) => (
                                                <tr key={`tab_content_person_${item?.user_id}`}>
                                                    <td className='rdotd'>
                                                        <input
                                                            type="radio"
                                                            name="fromContactList"
                                                            value={item?.user_id}
                                                            checked={values.fromContactList == item?.user_id}
                                                            onChange={(e) => { setFieldValue('fromContactList', e.target.checked ? item?.user_id : ''); }}
                                                            onBlur={handleBlur}
                                                        />
                                                    </td>
                                                    <td>{item?.first_name}</td>
                                                    <td>{item?.last_name}</td>
                                                    <td>{item?.email}</td>
                                                    <td>{item?.mobile_number}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">To</label>
                                <div className="table-responsive">
                                    <table className="table table-bordered text-nowrap mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{ width: 60 }}></th>
                                                <th style={{ width: 350 }}>First Name</th>
                                                <th style={{ width: 350 }}>Last Name</th>
                                                <th>Email Id</th>
                                                <th style={{ width: 350 }} className="txt-left">Mobile Number</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {leadInfoList?.client_person?.map((item) => (
                                                <tr key={`tab_content_person_${item?.user_id}`}>
                                                    <td className='rdotd'>
                                                        <input
                                                            type="checkbox"
                                                            value={item.user_id}
                                                            checked={selectedIds.includes(item.user_id)}
                                                            onChange={(e) => {
                                                                const id = item.user_id;
                                                                setSelectedIds(prev =>
                                                                    e.target.checked
                                                                        ? [...prev, id]
                                                                        : prev.filter(pid => pid !== id)
                                                                );
                                                            }}
                                                        />
                                                    </td>
                                                    <td>{item?.first_name}</td>
                                                    <td>{item?.last_name}</td>
                                                    <td>{item?.email}</td>
                                                    <td>{item?.mobile_number}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">CC</label>
                                <div className="table-responsive">
                                    <table className="table table-bordered text-nowrap mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{ width: 60 }}></th>
                                                <th style={{ width: 350 }}>First Name</th>
                                                <th style={{ width: 350 }}>Last Name</th>
                                                <th>Email Id</th>
                                                <th style={{ width: 350 }} className="txt-left">Mobile Number</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {leadInfoList?.billing_entity_person?.map((item) => (
                                                <tr key={`tab_content_person_${item?.user_id}`}>
                                                    <td className='rdotd'>
                                                        <input
                                                            type="checkbox"
                                                            value={item.user_id}
                                                            checked={ccselectedIds.includes(item.user_id)}
                                                            onChange={(e) => {
                                                                const id = item.user_id;
                                                                setccSelectedIds(prev =>
                                                                    e.target.checked
                                                                        ? [...prev, id]
                                                                        : prev.filter(pid => pid !== id)
                                                                );
                                                            }}
                                                        />
                                                    </td>
                                                    <td>{item?.first_name}</td>
                                                    <td>{item?.last_name}</td>
                                                    <td>{item?.email}</td>
                                                    <td>{item?.mobile_number}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Select Email Template</label>
                                <SelectFild
                                    Firstop='Select Email Template'
                                    selectName="activityoutputTemplateId"
                                    options={leadInfoList?.email_template}
                                    value={values.activityoutputTemplateId}
                                    onChange={(selectedOption) => {
                                        setFieldValue('activityoutputTemplateId', selectedOption?.value || "");
                                    }}
                                    onBlur={handleBlur}
                                />
                                {errors.activityoutputTemplateId && touched.activityoutputTemplateId && (
                                    <p className="errormsg">{errors.activityoutputTemplateId}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Subject</label>
                                <input
                                    type='text'
                                    id="subject"
                                    name="subject"
                                    className="form-control"
                                    value={values.subject}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.subject && touched.subject && (
                                    <p className="errormsg">{errors.subject}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Email Body</label>
                                <CKEditor
                                    editor={ClassicEditor}
                                    data={emailBody} // This should be a string
                                    config={{
                                        toolbar: [
                                            'undo', 'redo',
                                            '|',
                                            'heading',
                                            '|',
                                            'bold', 'italic', 'link',
                                            '|',
                                            'bulletedList', 'numberedList',
                                            '|',
                                            'blockQuote'
                                        ],
                                        htmlSupport: {
                                            allow: [
                                                {
                                                    name: /.*/,
                                                    attributes: true,
                                                    classes: true,
                                                    styles: true
                                                }
                                            ]
                                        }
                                    }}
                                    onChange={(event, editor) => {
                                        const data = editor.getData();
                                        setEmailBody(data);
                                    }}
                                    onReady={(editor) => {
                                        console.log('Editor is ready to use!', editor);
                                    }}
                                    onBlur={(event, editor) => {
                                        console.log('Blur.', editor);
                                    }}
                                    onFocus={(event, editor) => {
                                        console.log('Focus.', editor);
                                    }}
                                />
                                <div style={{ marginTop: '20px', display: 'none' }}>
                                    <h4>Preview</h4>
                                    <div dangerouslySetInnerHTML={{ __html: emailBody }} />
                                </div>
                            </div>
                        </Col>
                        {documentListData?.common_document?.length > 0 && (
                            <Col md={12}>
                                <div className='fieldsets'>
                                    <div className='fieldsets-title'>Common Document</div>
                                    <div className='attachmentsList'>
                                        <ul>
                                            {documentListData?.common_document?.map((item) => (
                                                <li>
                                                    <div className='listcards'>
                                                        <h4>{item?.document_title}</h4>
                                                        <ul>
                                                            {item?.files?.map((files) => (
                                                                <li>
                                                                    <div className='attBox'>
                                                                        <div className="chkBox">
                                                                            <input
                                                                                type="checkbox"
                                                                                value={files.document_file_id}
                                                                                checked={selectedDocument.includes(files.document_file_id)}
                                                                                onChange={(e) => {
                                                                                    const id = files.document_file_id;
                                                                                    setSelectedDocument(prev =>
                                                                                        e.target.checked
                                                                                            ? [...prev, id]
                                                                                            : prev.filter(pid => pid !== id)
                                                                                    );
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <div className="pdf-icon">
                                                                            <FaFilePdf size={16} color="#e74c3c" />
                                                                        </div>
                                                                        <p>{files?.file_name}</p>
                                                                        <a href={files?.file_url} target="_blank" className='btn btn-primary' rel="noopener noreferrer"><FaEye /></a>
                                                                    </div>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </Col>
                        )}
                    </Row>
                    <div className="previewsimges" style={{ paddingTop: 0 }}>
                        <div className='imageboxs'>
                            <div className='imgs pdfs'>
                                <div>
                                    <div className="pdf-icon">
                                        <FaFilePdf size={48} color="#e74c3c" />
                                    </div>
                                    <p>{leadInfoList?.last_quotation?.quotation_no}.pdf</p>
                                    <a href={leadInfoList?.last_quotation?.quotation_file} target="_blank" className='btn btn-primary' rel="noopener noreferrer">view Pdf</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Send</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            <Modals
                show={showLogModal}
                handleClose={() => setShowLogModal(false)}
                title="Communication Log"
                textColor='#000'
                size='xl'
                centered={true}
                backdrop={true}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={8}>
                            <Row>
                                <Col md={12}>
                                    <div className="form-group">
                                        <div className="table-responsive">
                                            <table className="table table-bordered text-nowrap mb-0">
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: 60 }}></th>
                                                        <th>First Name</th>
                                                        <th>Last Name</th>
                                                        <th>Email Id</th>
                                                        <th className="txt-left">Mobile Number</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {dropdownList?.contact_person?.map((item) => (
                                                        <tr key={`tab_content_person_${item?.contact_person_id}`}>
                                                            <td className='rdotd'>
                                                                <input
                                                                    type="radio"
                                                                    name="contactPersonId"
                                                                    value={item?.contact_person_id}
                                                                    checked={values.contactPersonId == item?.contact_person_id}
                                                                    onChange={(e) => { setFieldValue('contactPersonId', e.target.checked ? item?.contact_person_id : ''); }}
                                                                    onBlur={handleBlur}
                                                                />
                                                            </td>
                                                            <td>{item?.first_name}</td>
                                                            <td>{item?.last_name}</td>
                                                            <td>{item?.email}</td>
                                                            <td>{item?.mobile_number}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={12}>
                                    <div className="form-group">
                                        <div className='d-flex align-items-center'>
                                            <label className='mb-0'>Communication Types :</label>
                                            <div className='typeList'>
                                                {dropdownList?.communication_type?.map((item) => (
                                                    <div className='litBoxs' key={`typeIds_${item?.com_type_id}`}>
                                                        <input
                                                            type="radio"
                                                            name="typeId"
                                                            value={item?.com_type_id}
                                                            checked={values.typeId == item?.com_type_id}
                                                            onChange={(e) => {
                                                                if (e.target.checked) {
                                                                    setFieldValue('typeId', item?.com_type_id);
                                                                    setStatusList(item?.statuses)
                                                                }
                                                            }}
                                                            onBlur={handleBlur}
                                                        />
                                                        <div className='listContent'>
                                                            <img src={item?.com_type_icon} className="typeIo" alt={item?.com_type_name} title={item?.com_type_name} />
                                                            <p>{item?.com_type_name}</p>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">interaction Date</label>
                                        <DateToDayFild
                                            value={values.interactionDate}
                                            onChange={(date) => setFieldValue('interactionDate', date)}
                                            isMin={false}
                                            isMax={true}
                                        />
                                        {errors.interactionDate && touched.interactionDate && (
                                            <p className="errormsg">{errors.interactionDate}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">interaction Time</label>
                                        <TimeFild
                                            value={values.interactionTime}
                                            onChange={(time) => setFieldValue('interactionTime', time)}
                                            format="local"
                                        />
                                        {errors.interactionTime && touched.interactionTime && (
                                            <p className="errormsg">{errors.interactionTime}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">Select interaction Mode</label>
                                        <SelectFild
                                            Firstop='Select Interaction Mode'
                                            selectName="interactionMode"
                                            options={dropdownList?.interaction_mode}
                                            value={values.interactionMode}
                                            onChange={(selectedOption) => setFieldValue("interactionMode", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.interactionMode && touched.interactionMode && (
                                            <p className="errormsg">{errors.interactionMode}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">Select Status</label>
                                        <SelectFild
                                            Firstop='Select Status'
                                            selectName="statusId"
                                            options={statusList}
                                            value={values.statusId}
                                            onChange={(selectedOption) => setFieldValue("statusId", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.statusId && touched.statusId && (
                                            <p className="errormsg">{errors.statusId}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">duration Minutes</label>
                                        <input
                                            type='text'
                                            id="durationMinutes"
                                            name="durationMinutes"
                                            className="form-control"
                                            autoComplete='off'
                                            value={values.durationMinutes}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {errors.durationMinutes && touched.durationMinutes && (
                                            <p className="errormsg">{errors.durationMinutes}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">Next Scheduled Date</label>
                                        <DateToDayFild
                                            value={values.nextFollowUpDate}
                                            onChange={(date) => setFieldValue('nextFollowUpDate', date)}
                                            isMin={true}
                                            isMax={false}
                                        />
                                        {errors.nextFollowUpDate && touched.nextFollowUpDate && (
                                            <p className="errormsg">{errors.nextFollowUpDate}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={12}>
                                    <div className="form-group">
                                        <label className="form-label">Notes</label>
                                        <textarea
                                            id="notes"
                                            name="notes"
                                            className="form-control"
                                            autoComplete='off'
                                            value={values.notes}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {errors.notes && touched.notes && (
                                            <p className="errormsg">{errors.notes}</p>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={4}>
                            <div className="ScheduledBlock">
                                <h1>Communication History</h1>
                                <div className="Scheduledbox">
                                    <ul>
                                        {logHistory?.map((item) => (
                                            <li key={item?.interaction_id}>
                                                <div className='scheduled-date'>
                                                    <h6>{item?.interaction_datetime?.split(" ")?.[0]}</h6>
                                                    <p>{item?.interaction_datetime?.split(" ")?.[1]}</p>
                                                </div>
                                                <div className='scheduled-io'>
                                                    <FaCheckCircle />
                                                </div>
                                                <div className='scheduled-content'>
                                                    <h4>{item?.interaction_to?.name}</h4>
                                                    <p>{item?.status?.status_name}</p>
                                                    <p>Next Follow-up Date: {item?.next_follow_up_date}</p>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>

                        </Col>
                    </Row>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Save</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            {isLoadings && <Loader />}
        </>
    )
}

export default Leads